var cov_1hl321vx4v = function () {
  var path = '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/custom_database/design/designCtrl.js',
      hash = 'bb1fb9db1a787544dee1a12efd02145948b99e8a',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/custom_database/design/designCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 650,
          column: 3
        }
      },
      '1': {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 2,
          column: 37
        }
      },
      '2': {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 5,
          column: 3
        }
      },
      '3': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 11
        }
      },
      '4': {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 6,
          column: 41
        }
      },
      '5': {
        start: {
          line: 7,
          column: 15
        },
        end: {
          line: 7,
          column: 25
        }
      },
      '6': {
        start: {
          line: 8,
          column: 22
        },
        end: {
          line: 8,
          column: 47
        }
      },
      '7': {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 12,
          column: 4
        }
      },
      '8': {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 31
        }
      },
      '9': {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 20
        }
      },
      '10': {
        start: {
          line: 13,
          column: 20
        },
        end: {
          line: 16,
          column: 3
        }
      },
      '11': {
        start: {
          line: 14,
          column: 14
        },
        end: {
          line: 14,
          column: 47
        }
      },
      '12': {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 40
        }
      },
      '13': {
        start: {
          line: 18,
          column: 28
        },
        end: {
          line: 33,
          column: 3
        }
      },
      '14': {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 36
        }
      },
      '15': {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 32
        }
      },
      '16': {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 36,
          column: 4
        }
      },
      '17': {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 65
        }
      },
      '18': {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 37,
          column: 29
        }
      },
      '19': {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 52,
          column: 5
        }
      },
      '20': {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 54,
          column: 18
        }
      },
      '21': {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 57,
          column: 4
        }
      },
      '22': {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 29
        }
      },
      '23': {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 76,
          column: 4
        }
      },
      '24': {
        start: {
          line: 61,
          column: 19
        },
        end: {
          line: 61,
          column: 21
        }
      },
      '25': {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 68,
          column: 9
        }
      },
      '26': {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 62
        }
      },
      '27': {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 24
        }
      },
      '28': {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 74,
          column: 7
        }
      },
      '29': {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 72,
          column: 43
        }
      },
      '30': {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 73,
          column: 43
        }
      },
      '31': {
        start: {
          line: 78,
          column: 22
        },
        end: {
          line: 78,
          column: 46
        }
      },
      '32': {
        start: {
          line: 79,
          column: 2
        },
        end: {
          line: 501,
          column: 4
        }
      },
      '33': {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 31
        }
      },
      '34': {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 85,
          column: 22
        }
      },
      '35': {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 86,
          column: 27
        }
      },
      '36': {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 89,
          column: 7
        }
      },
      '37': {
        start: {
          line: 88,
          column: 8
        },
        end: {
          line: 88,
          column: 25
        }
      },
      '38': {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 90,
          column: 33
        }
      },
      '39': {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 96,
          column: 7
        }
      },
      '40': {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 94,
          column: 9
        }
      },
      '41': {
        start: {
          line: 93,
          column: 10
        },
        end: {
          line: 93,
          column: 19
        }
      },
      '42': {
        start: {
          line: 95,
          column: 8
        },
        end: {
          line: 95,
          column: 39
        }
      },
      '43': {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 104,
          column: 7
        }
      },
      '44': {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 98,
          column: 90
        }
      },
      '45': {
        start: {
          line: 99,
          column: 8
        },
        end: {
          line: 103,
          column: 9
        }
      },
      '46': {
        start: {
          line: 100,
          column: 10
        },
        end: {
          line: 102,
          column: 11
        }
      },
      '47': {
        start: {
          line: 101,
          column: 12
        },
        end: {
          line: 101,
          column: 60
        }
      },
      '48': {
        start: {
          line: 107,
          column: 15
        },
        end: {
          line: 107,
          column: 19
        }
      },
      '49': {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 114,
          column: 7
        }
      },
      '50': {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 113,
          column: 9
        }
      },
      '51': {
        start: {
          line: 110,
          column: 10
        },
        end: {
          line: 112,
          column: 11
        }
      },
      '52': {
        start: {
          line: 111,
          column: 12
        },
        end: {
          line: 111,
          column: 25
        }
      },
      '53': {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 116,
          column: 45
        }
      },
      '54': {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 14
        }
      },
      '55': {
        start: {
          line: 118,
          column: 6
        },
        end: {
          line: 118,
          column: 20
        }
      },
      '56': {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 121,
          column: 78
        }
      },
      '57': {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 127,
          column: 7
        }
      },
      '58': {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 76
        }
      },
      '59': {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 130,
          column: 42
        }
      },
      '60': {
        start: {
          line: 131,
          column: 6
        },
        end: {
          line: 131,
          column: 30
        }
      },
      '61': {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 137,
          column: 7
        }
      },
      '62': {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 135,
          column: 28
        }
      },
      '63': {
        start: {
          line: 136,
          column: 8
        },
        end: {
          line: 136,
          column: 30
        }
      },
      '64': {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 140,
          column: 41
        }
      },
      '65': {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 148,
          column: 7
        }
      },
      '66': {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 147,
          column: 9
        }
      },
      '67': {
        start: {
          line: 143,
          column: 10
        },
        end: {
          line: 145,
          column: 11
        }
      },
      '68': {
        start: {
          line: 144,
          column: 12
        },
        end: {
          line: 144,
          column: 21
        }
      },
      '69': {
        start: {
          line: 146,
          column: 10
        },
        end: {
          line: 146,
          column: 26
        }
      },
      '70': {
        start: {
          line: 188,
          column: 6
        },
        end: {
          line: 188,
          column: 30
        }
      },
      '71': {
        start: {
          line: 189,
          column: 6
        },
        end: {
          line: 189,
          column: 31
        }
      },
      '72': {
        start: {
          line: 190,
          column: 6
        },
        end: {
          line: 197,
          column: 9
        }
      },
      '73': {
        start: {
          line: 191,
          column: 8
        },
        end: {
          line: 194,
          column: 11
        }
      },
      '74': {
        start: {
          line: 192,
          column: 10
        },
        end: {
          line: 192,
          column: 68
        }
      },
      '75': {
        start: {
          line: 193,
          column: 10
        },
        end: {
          line: 193,
          column: 22
        }
      },
      '76': {
        start: {
          line: 195,
          column: 8
        },
        end: {
          line: 195,
          column: 33
        }
      },
      '77': {
        start: {
          line: 196,
          column: 8
        },
        end: {
          line: 196,
          column: 33
        }
      },
      '78': {
        start: {
          line: 200,
          column: 6
        },
        end: {
          line: 209,
          column: 9
        }
      },
      '79': {
        start: {
          line: 212,
          column: 6
        },
        end: {
          line: 215,
          column: 7
        }
      },
      '80': {
        start: {
          line: 213,
          column: 8
        },
        end: {
          line: 213,
          column: 64
        }
      },
      '81': {
        start: {
          line: 214,
          column: 8
        },
        end: {
          line: 214,
          column: 15
        }
      },
      '82': {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 236,
          column: 9
        }
      },
      '83': {
        start: {
          line: 228,
          column: 8
        },
        end: {
          line: 230,
          column: 9
        }
      },
      '84': {
        start: {
          line: 229,
          column: 10
        },
        end: {
          line: 229,
          column: 17
        }
      },
      '85': {
        start: {
          line: 231,
          column: 8
        },
        end: {
          line: 231,
          column: 32
        }
      },
      '86': {
        start: {
          line: 232,
          column: 8
        },
        end: {
          line: 235,
          column: 11
        }
      },
      '87': {
        start: {
          line: 233,
          column: 10
        },
        end: {
          line: 233,
          column: 35
        }
      },
      '88': {
        start: {
          line: 234,
          column: 10
        },
        end: {
          line: 234,
          column: 35
        }
      },
      '89': {
        start: {
          line: 239,
          column: 6
        },
        end: {
          line: 239,
          column: 38
        }
      },
      '90': {
        start: {
          line: 240,
          column: 6
        },
        end: {
          line: 240,
          column: 22
        }
      },
      '91': {
        start: {
          line: 241,
          column: 6
        },
        end: {
          line: 241,
          column: 31
        }
      },
      '92': {
        start: {
          line: 244,
          column: 23
        },
        end: {
          line: 244,
          column: 25
        }
      },
      '93': {
        start: {
          line: 245,
          column: 6
        },
        end: {
          line: 247,
          column: 7
        }
      },
      '94': {
        start: {
          line: 246,
          column: 8
        },
        end: {
          line: 246,
          column: 86
        }
      },
      '95': {
        start: {
          line: 248,
          column: 6
        },
        end: {
          line: 248,
          column: 54
        }
      },
      '96': {
        start: {
          line: 249,
          column: 6
        },
        end: {
          line: 251,
          column: 7
        }
      },
      '97': {
        start: {
          line: 250,
          column: 8
        },
        end: {
          line: 250,
          column: 15
        }
      },
      '98': {
        start: {
          line: 252,
          column: 6
        },
        end: {
          line: 258,
          column: 7
        }
      },
      '99': {
        start: {
          line: 253,
          column: 8
        },
        end: {
          line: 257,
          column: 9
        }
      },
      '100': {
        start: {
          line: 254,
          column: 10
        },
        end: {
          line: 256,
          column: 11
        }
      },
      '101': {
        start: {
          line: 255,
          column: 12
        },
        end: {
          line: 255,
          column: 19
        }
      },
      '102': {
        start: {
          line: 260,
          column: 21
        },
        end: {
          line: 260,
          column: 62
        }
      },
      '103': {
        start: {
          line: 273,
          column: 6
        },
        end: {
          line: 307,
          column: 7
        }
      },
      '104': {
        start: {
          line: 274,
          column: 21
        },
        end: {
          line: 274,
          column: 44
        }
      },
      '105': {
        start: {
          line: 275,
          column: 8
        },
        end: {
          line: 306,
          column: 9
        }
      },
      '106': {
        start: {
          line: 276,
          column: 25
        },
        end: {
          line: 276,
          column: 76
        }
      },
      '107': {
        start: {
          line: 278,
          column: 10
        },
        end: {
          line: 305,
          column: 11
        }
      },
      '108': {
        start: {
          line: 279,
          column: 12
        },
        end: {
          line: 303,
          column: 15
        }
      },
      '109': {
        start: {
          line: 290,
          column: 14
        },
        end: {
          line: 292,
          column: 15
        }
      },
      '110': {
        start: {
          line: 291,
          column: 16
        },
        end: {
          line: 291,
          column: 23
        }
      },
      '111': {
        start: {
          line: 293,
          column: 14
        },
        end: {
          line: 293,
          column: 51
        }
      },
      '112': {
        start: {
          line: 294,
          column: 31
        },
        end: {
          line: 294,
          column: 69
        }
      },
      '113': {
        start: {
          line: 295,
          column: 14
        },
        end: {
          line: 295,
          column: 38
        }
      },
      '114': {
        start: {
          line: 296,
          column: 14
        },
        end: {
          line: 298,
          column: 15
        }
      },
      '115': {
        start: {
          line: 297,
          column: 16
        },
        end: {
          line: 297,
          column: 57
        }
      },
      '116': {
        start: {
          line: 299,
          column: 14
        },
        end: {
          line: 302,
          column: 17
        }
      },
      '117': {
        start: {
          line: 300,
          column: 16
        },
        end: {
          line: 300,
          column: 41
        }
      },
      '118': {
        start: {
          line: 301,
          column: 16
        },
        end: {
          line: 301,
          column: 41
        }
      },
      '119': {
        start: {
          line: 304,
          column: 12
        },
        end: {
          line: 304,
          column: 19
        }
      },
      '120': {
        start: {
          line: 308,
          column: 6
        },
        end: {
          line: 308,
          column: 43
        }
      },
      '121': {
        start: {
          line: 309,
          column: 23
        },
        end: {
          line: 309,
          column: 61
        }
      },
      '122': {
        start: {
          line: 310,
          column: 6
        },
        end: {
          line: 310,
          column: 30
        }
      },
      '123': {
        start: {
          line: 311,
          column: 6
        },
        end: {
          line: 314,
          column: 9
        }
      },
      '124': {
        start: {
          line: 312,
          column: 8
        },
        end: {
          line: 312,
          column: 33
        }
      },
      '125': {
        start: {
          line: 313,
          column: 8
        },
        end: {
          line: 313,
          column: 33
        }
      },
      '126': {
        start: {
          line: 317,
          column: 31
        },
        end: {
          line: 317,
          column: 85
        }
      },
      '127': {
        start: {
          line: 318,
          column: 31
        },
        end: {
          line: 318,
          column: 85
        }
      },
      '128': {
        start: {
          line: 320,
          column: 6
        },
        end: {
          line: 322,
          column: 7
        }
      },
      '129': {
        start: {
          line: 321,
          column: 8
        },
        end: {
          line: 321,
          column: 18
        }
      },
      '130': {
        start: {
          line: 326,
          column: 18
        },
        end: {
          line: 326,
          column: 20
        }
      },
      '131': {
        start: {
          line: 327,
          column: 6
        },
        end: {
          line: 334,
          column: 7
        }
      },
      '132': {
        start: {
          line: 328,
          column: 24
        },
        end: {
          line: 328,
          column: 86
        }
      },
      '133': {
        start: {
          line: 329,
          column: 8
        },
        end: {
          line: 333,
          column: 9
        }
      },
      '134': {
        start: {
          line: 330,
          column: 10
        },
        end: {
          line: 330,
          column: 33
        }
      },
      '135': {
        start: {
          line: 332,
          column: 10
        },
        end: {
          line: 332,
          column: 70
        }
      },
      '136': {
        start: {
          line: 335,
          column: 6
        },
        end: {
          line: 335,
          column: 19
        }
      },
      '137': {
        start: {
          line: 338,
          column: 6
        },
        end: {
          line: 340,
          column: 7
        }
      },
      '138': {
        start: {
          line: 339,
          column: 8
        },
        end: {
          line: 339,
          column: 15
        }
      },
      '139': {
        start: {
          line: 341,
          column: 6
        },
        end: {
          line: 347,
          column: 7
        }
      },
      '140': {
        start: {
          line: 342,
          column: 8
        },
        end: {
          line: 342,
          column: 27
        }
      },
      '141': {
        start: {
          line: 343,
          column: 8
        },
        end: {
          line: 343,
          column: 33
        }
      },
      '142': {
        start: {
          line: 344,
          column: 8
        },
        end: {
          line: 344,
          column: 37
        }
      },
      '143': {
        start: {
          line: 346,
          column: 8
        },
        end: {
          line: 346,
          column: 35
        }
      },
      '144': {
        start: {
          line: 348,
          column: 6
        },
        end: {
          line: 348,
          column: 22
        }
      },
      '145': {
        start: {
          line: 349,
          column: 6
        },
        end: {
          line: 351,
          column: 7
        }
      },
      '146': {
        start: {
          line: 350,
          column: 8
        },
        end: {
          line: 350,
          column: 29
        }
      },
      '147': {
        start: {
          line: 352,
          column: 6
        },
        end: {
          line: 352,
          column: 44
        }
      },
      '148': {
        start: {
          line: 353,
          column: 6
        },
        end: {
          line: 353,
          column: 30
        }
      },
      '149': {
        start: {
          line: 354,
          column: 6
        },
        end: {
          line: 354,
          column: 30
        }
      },
      '150': {
        start: {
          line: 355,
          column: 6
        },
        end: {
          line: 386,
          column: 9
        }
      },
      '151': {
        start: {
          line: 356,
          column: 8
        },
        end: {
          line: 356,
          column: 60
        }
      },
      '152': {
        start: {
          line: 357,
          column: 8
        },
        end: {
          line: 357,
          column: 58
        }
      },
      '153': {
        start: {
          line: 358,
          column: 8
        },
        end: {
          line: 360,
          column: 9
        }
      },
      '154': {
        start: {
          line: 359,
          column: 10
        },
        end: {
          line: 359,
          column: 41
        }
      },
      '155': {
        start: {
          line: 362,
          column: 8
        },
        end: {
          line: 364,
          column: 9
        }
      },
      '156': {
        start: {
          line: 363,
          column: 10
        },
        end: {
          line: 363,
          column: 59
        }
      },
      '157': {
        start: {
          line: 367,
          column: 25
        },
        end: {
          line: 367,
          column: 93
        }
      },
      '158': {
        start: {
          line: 368,
          column: 8
        },
        end: {
          line: 382,
          column: 9
        }
      },
      '159': {
        start: {
          line: 369,
          column: 21
        },
        end: {
          line: 369,
          column: 31
        }
      },
      '160': {
        start: {
          line: 370,
          column: 10
        },
        end: {
          line: 372,
          column: 11
        }
      },
      '161': {
        start: {
          line: 371,
          column: 12
        },
        end: {
          line: 371,
          column: 21
        }
      },
      '162': {
        start: {
          line: 373,
          column: 10
        },
        end: {
          line: 373,
          column: 72
        }
      },
      '163': {
        start: {
          line: 375,
          column: 10
        },
        end: {
          line: 377,
          column: 13
        }
      },
      '164': {
        start: {
          line: 376,
          column: 12
        },
        end: {
          line: 376,
          column: 61
        }
      },
      '165': {
        start: {
          line: 379,
          column: 10
        },
        end: {
          line: 381,
          column: 13
        }
      },
      '166': {
        start: {
          line: 380,
          column: 12
        },
        end: {
          line: 380,
          column: 63
        }
      },
      '167': {
        start: {
          line: 385,
          column: 8
        },
        end: {
          line: 385,
          column: 32
        }
      },
      '168': {
        start: {
          line: 390,
          column: 18
        },
        end: {
          line: 390,
          column: 36
        }
      },
      '169': {
        start: {
          line: 391,
          column: 6
        },
        end: {
          line: 416,
          column: 7
        }
      },
      '170': {
        start: {
          line: 392,
          column: 8
        },
        end: {
          line: 392,
          column: 32
        }
      },
      '171': {
        start: {
          line: 393,
          column: 8
        },
        end: {
          line: 414,
          column: 11
        }
      },
      '172': {
        start: {
          line: 394,
          column: 10
        },
        end: {
          line: 394,
          column: 35
        }
      },
      '173': {
        start: {
          line: 395,
          column: 10
        },
        end: {
          line: 395,
          column: 37
        }
      },
      '174': {
        start: {
          line: 396,
          column: 10
        },
        end: {
          line: 396,
          column: 31
        }
      },
      '175': {
        start: {
          line: 397,
          column: 10
        },
        end: {
          line: 399,
          column: 11
        }
      },
      '176': {
        start: {
          line: 398,
          column: 12
        },
        end: {
          line: 398,
          column: 57
        }
      },
      '177': {
        start: {
          line: 401,
          column: 10
        },
        end: {
          line: 403,
          column: 11
        }
      },
      '178': {
        start: {
          line: 402,
          column: 12
        },
        end: {
          line: 402,
          column: 41
        }
      },
      '179': {
        start: {
          line: 405,
          column: 10
        },
        end: {
          line: 410,
          column: 11
        }
      },
      '180': {
        start: {
          line: 406,
          column: 12
        },
        end: {
          line: 408,
          column: 13
        }
      },
      '181': {
        start: {
          line: 407,
          column: 14
        },
        end: {
          line: 407,
          column: 47
        }
      },
      '182': {
        start: {
          line: 409,
          column: 12
        },
        end: {
          line: 409,
          column: 55
        }
      },
      '183': {
        start: {
          line: 411,
          column: 10
        },
        end: {
          line: 411,
          column: 58
        }
      },
      '184': {
        start: {
          line: 412,
          column: 10
        },
        end: {
          line: 412,
          column: 41
        }
      },
      '185': {
        start: {
          line: 413,
          column: 10
        },
        end: {
          line: 413,
          column: 35
        }
      },
      '186': {
        start: {
          line: 415,
          column: 8
        },
        end: {
          line: 415,
          column: 15
        }
      },
      '187': {
        start: {
          line: 417,
          column: 6
        },
        end: {
          line: 417,
          column: 27
        }
      },
      '188': {
        start: {
          line: 418,
          column: 6
        },
        end: {
          line: 420,
          column: 7
        }
      },
      '189': {
        start: {
          line: 419,
          column: 8
        },
        end: {
          line: 419,
          column: 53
        }
      },
      '190': {
        start: {
          line: 421,
          column: 6
        },
        end: {
          line: 423,
          column: 7
        }
      },
      '191': {
        start: {
          line: 422,
          column: 8
        },
        end: {
          line: 422,
          column: 37
        }
      },
      '192': {
        start: {
          line: 425,
          column: 6
        },
        end: {
          line: 425,
          column: 55
        }
      },
      '193': {
        start: {
          line: 426,
          column: 6
        },
        end: {
          line: 426,
          column: 37
        }
      },
      '194': {
        start: {
          line: 427,
          column: 6
        },
        end: {
          line: 427,
          column: 31
        }
      },
      '195': {
        start: {
          line: 430,
          column: 6
        },
        end: {
          line: 430,
          column: 33
        }
      },
      '196': {
        start: {
          line: 431,
          column: 6
        },
        end: {
          line: 431,
          column: 22
        }
      },
      '197': {
        start: {
          line: 434,
          column: 17
        },
        end: {
          line: 434,
          column: 28
        }
      },
      '198': {
        start: {
          line: 435,
          column: 6
        },
        end: {
          line: 435,
          column: 58
        }
      },
      '199': {
        start: {
          line: 436,
          column: 18
        },
        end: {
          line: 436,
          column: 97
        }
      },
      '200': {
        start: {
          line: 437,
          column: 6
        },
        end: {
          line: 437,
          column: 54
        }
      },
      '201': {
        start: {
          line: 438,
          column: 6
        },
        end: {
          line: 438,
          column: 27
        }
      },
      '202': {
        start: {
          line: 441,
          column: 6
        },
        end: {
          line: 441,
          column: 34
        }
      },
      '203': {
        start: {
          line: 442,
          column: 6
        },
        end: {
          line: 442,
          column: 32
        }
      },
      '204': {
        start: {
          line: 445,
          column: 6
        },
        end: {
          line: 447,
          column: 7
        }
      },
      '205': {
        start: {
          line: 446,
          column: 8
        },
        end: {
          line: 446,
          column: 15
        }
      },
      '206': {
        start: {
          line: 448,
          column: 6
        },
        end: {
          line: 455,
          column: 7
        }
      },
      '207': {
        start: {
          line: 449,
          column: 8
        },
        end: {
          line: 454,
          column: 9
        }
      },
      '208': {
        start: {
          line: 450,
          column: 10
        },
        end: {
          line: 450,
          column: 34
        }
      },
      '209': {
        start: {
          line: 451,
          column: 10
        },
        end: {
          line: 451,
          column: 33
        }
      },
      '210': {
        start: {
          line: 452,
          column: 10
        },
        end: {
          line: 452,
          column: 30
        }
      },
      '211': {
        start: {
          line: 453,
          column: 10
        },
        end: {
          line: 453,
          column: 16
        }
      },
      '212': {
        start: {
          line: 456,
          column: 6
        },
        end: {
          line: 456,
          column: 28
        }
      },
      '213': {
        start: {
          line: 459,
          column: 21
        },
        end: {
          line: 459,
          column: 61
        }
      },
      '214': {
        start: {
          line: 460,
          column: 6
        },
        end: {
          line: 464,
          column: 7
        }
      },
      '215': {
        start: {
          line: 461,
          column: 8
        },
        end: {
          line: 463,
          column: 9
        }
      },
      '216': {
        start: {
          line: 462,
          column: 10
        },
        end: {
          line: 462,
          column: 50
        }
      },
      '217': {
        start: {
          line: 465,
          column: 6
        },
        end: {
          line: 465,
          column: 28
        }
      },
      '218': {
        start: {
          line: 468,
          column: 6
        },
        end: {
          line: 471,
          column: 7
        }
      },
      '219': {
        start: {
          line: 469,
          column: 8
        },
        end: {
          line: 469,
          column: 28
        }
      },
      '220': {
        start: {
          line: 470,
          column: 8
        },
        end: {
          line: 470,
          column: 30
        }
      },
      '221': {
        start: {
          line: 474,
          column: 26
        },
        end: {
          line: 474,
          column: 27
        }
      },
      '222': {
        start: {
          line: 475,
          column: 6
        },
        end: {
          line: 479,
          column: 7
        }
      },
      '223': {
        start: {
          line: 476,
          column: 8
        },
        end: {
          line: 478,
          column: 9
        }
      },
      '224': {
        start: {
          line: 477,
          column: 10
        },
        end: {
          line: 477,
          column: 28
        }
      },
      '225': {
        start: {
          line: 480,
          column: 6
        },
        end: {
          line: 482,
          column: 7
        }
      },
      '226': {
        start: {
          line: 481,
          column: 8
        },
        end: {
          line: 481,
          column: 15
        }
      },
      '227': {
        start: {
          line: 483,
          column: 6
        },
        end: {
          line: 483,
          column: 98
        }
      },
      '228': {
        start: {
          line: 484,
          column: 6
        },
        end: {
          line: 484,
          column: 57
        }
      },
      '229': {
        start: {
          line: 485,
          column: 6
        },
        end: {
          line: 490,
          column: 7
        }
      },
      '230': {
        start: {
          line: 486,
          column: 8
        },
        end: {
          line: 486,
          column: 24
        }
      },
      '231': {
        start: {
          line: 487,
          column: 8
        },
        end: {
          line: 489,
          column: 9
        }
      },
      '232': {
        start: {
          line: 488,
          column: 10
        },
        end: {
          line: 488,
          column: 28
        }
      },
      '233': {
        start: {
          line: 491,
          column: 6
        },
        end: {
          line: 491,
          column: 88
        }
      },
      '234': {
        start: {
          line: 492,
          column: 6
        },
        end: {
          line: 492,
          column: 26
        }
      },
      '235': {
        start: {
          line: 495,
          column: 6
        },
        end: {
          line: 495,
          column: 58
        }
      },
      '236': {
        start: {
          line: 499,
          column: 6
        },
        end: {
          line: 499,
          column: 76
        }
      },
      '237': {
        start: {
          line: 502,
          column: 2
        },
        end: {
          line: 612,
          column: 4
        }
      },
      '238': {
        start: {
          line: 505,
          column: 6
        },
        end: {
          line: 505,
          column: 65
        }
      },
      '239': {
        start: {
          line: 506,
          column: 6
        },
        end: {
          line: 509,
          column: 7
        }
      },
      '240': {
        start: {
          line: 507,
          column: 8
        },
        end: {
          line: 507,
          column: 28
        }
      },
      '241': {
        start: {
          line: 508,
          column: 8
        },
        end: {
          line: 508,
          column: 49
        }
      },
      '242': {
        start: {
          line: 510,
          column: 6
        },
        end: {
          line: 510,
          column: 38
        }
      },
      '243': {
        start: {
          line: 511,
          column: 6
        },
        end: {
          line: 511,
          column: 74
        }
      },
      '244': {
        start: {
          line: 512,
          column: 6
        },
        end: {
          line: 512,
          column: 37
        }
      },
      '245': {
        start: {
          line: 515,
          column: 6
        },
        end: {
          line: 515,
          column: 53
        }
      },
      '246': {
        start: {
          line: 516,
          column: 6
        },
        end: {
          line: 516,
          column: 74
        }
      },
      '247': {
        start: {
          line: 517,
          column: 6
        },
        end: {
          line: 517,
          column: 37
        }
      },
      '248': {
        start: {
          line: 520,
          column: 19
        },
        end: {
          line: 520,
          column: 57
        }
      },
      '249': {
        start: {
          line: 521,
          column: 6
        },
        end: {
          line: 521,
          column: 53
        }
      },
      '250': {
        start: {
          line: 523,
          column: 6
        },
        end: {
          line: 534,
          column: 7
        }
      },
      '251': {
        start: {
          line: 524,
          column: 8
        },
        end: {
          line: 526,
          column: 9
        }
      },
      '252': {
        start: {
          line: 525,
          column: 10
        },
        end: {
          line: 525,
          column: 19
        }
      },
      '253': {
        start: {
          line: 527,
          column: 8
        },
        end: {
          line: 532,
          column: 9
        }
      },
      '254': {
        start: {
          line: 528,
          column: 10
        },
        end: {
          line: 531,
          column: 11
        }
      },
      '255': {
        start: {
          line: 529,
          column: 12
        },
        end: {
          line: 529,
          column: 69
        }
      },
      '256': {
        start: {
          line: 530,
          column: 12
        },
        end: {
          line: 530,
          column: 18
        }
      },
      '257': {
        start: {
          line: 533,
          column: 8
        },
        end: {
          line: 533,
          column: 14
        }
      },
      '258': {
        start: {
          line: 535,
          column: 6
        },
        end: {
          line: 535,
          column: 74
        }
      },
      '259': {
        start: {
          line: 536,
          column: 6
        },
        end: {
          line: 536,
          column: 37
        }
      },
      '260': {
        start: {
          line: 539,
          column: 21
        },
        end: {
          line: 539,
          column: 54
        }
      },
      '261': {
        start: {
          line: 540,
          column: 6
        },
        end: {
          line: 554,
          column: 7
        }
      },
      '262': {
        start: {
          line: 542,
          column: 10
        },
        end: {
          line: 542,
          column: 34
        }
      },
      '263': {
        start: {
          line: 543,
          column: 10
        },
        end: {
          line: 543,
          column: 16
        }
      },
      '264': {
        start: {
          line: 545,
          column: 10
        },
        end: {
          line: 545,
          column: 36
        }
      },
      '265': {
        start: {
          line: 546,
          column: 10
        },
        end: {
          line: 546,
          column: 16
        }
      },
      '266': {
        start: {
          line: 548,
          column: 10
        },
        end: {
          line: 548,
          column: 34
        }
      },
      '267': {
        start: {
          line: 549,
          column: 10
        },
        end: {
          line: 549,
          column: 16
        }
      },
      '268': {
        start: {
          line: 551,
          column: 10
        },
        end: {
          line: 551,
          column: 32
        }
      },
      '269': {
        start: {
          line: 552,
          column: 10
        },
        end: {
          line: 552,
          column: 16
        }
      },
      '270': {
        start: {
          line: 555,
          column: 6
        },
        end: {
          line: 555,
          column: 39
        }
      },
      '271': {
        start: {
          line: 556,
          column: 6
        },
        end: {
          line: 556,
          column: 41
        }
      },
      '272': {
        start: {
          line: 558,
          column: 6
        },
        end: {
          line: 560,
          column: 7
        }
      },
      '273': {
        start: {
          line: 559,
          column: 8
        },
        end: {
          line: 559,
          column: 103
        }
      },
      '274': {
        start: {
          line: 562,
          column: 6
        },
        end: {
          line: 562,
          column: 26
        }
      },
      '275': {
        start: {
          line: 563,
          column: 6
        },
        end: {
          line: 570,
          column: 9
        }
      },
      '276': {
        start: {
          line: 574,
          column: 20
        },
        end: {
          line: 574,
          column: 95
        }
      },
      '277': {
        start: {
          line: 575,
          column: 6
        },
        end: {
          line: 577,
          column: 7
        }
      },
      '278': {
        start: {
          line: 576,
          column: 8
        },
        end: {
          line: 576,
          column: 87
        }
      },
      '279': {
        start: {
          line: 580,
          column: 6
        },
        end: {
          line: 584,
          column: 7
        }
      },
      '280': {
        start: {
          line: 581,
          column: 8
        },
        end: {
          line: 581,
          column: 49
        }
      },
      '281': {
        start: {
          line: 583,
          column: 8
        },
        end: {
          line: 583,
          column: 38
        }
      },
      '282': {
        start: {
          line: 585,
          column: 20
        },
        end: {
          line: 585,
          column: 116
        }
      },
      '283': {
        start: {
          line: 586,
          column: 6
        },
        end: {
          line: 588,
          column: 7
        }
      },
      '284': {
        start: {
          line: 587,
          column: 8
        },
        end: {
          line: 587,
          column: 93
        }
      },
      '285': {
        start: {
          line: 591,
          column: 6
        },
        end: {
          line: 593,
          column: 7
        }
      },
      '286': {
        start: {
          line: 592,
          column: 8
        },
        end: {
          line: 592,
          column: 15
        }
      },
      '287': {
        start: {
          line: 594,
          column: 6
        },
        end: {
          line: 596,
          column: 7
        }
      },
      '288': {
        start: {
          line: 595,
          column: 8
        },
        end: {
          line: 595,
          column: 15
        }
      },
      '289': {
        start: {
          line: 597,
          column: 18
        },
        end: {
          line: 597,
          column: 54
        }
      },
      '290': {
        start: {
          line: 598,
          column: 20
        },
        end: {
          line: 598,
          column: 45
        }
      },
      '291': {
        start: {
          line: 599,
          column: 6
        },
        end: {
          line: 601,
          column: 7
        }
      },
      '292': {
        start: {
          line: 600,
          column: 8
        },
        end: {
          line: 600,
          column: 15
        }
      },
      '293': {
        start: {
          line: 602,
          column: 6
        },
        end: {
          line: 602,
          column: 29
        }
      },
      '294': {
        start: {
          line: 603,
          column: 6
        },
        end: {
          line: 603,
          column: 27
        }
      },
      '295': {
        start: {
          line: 606,
          column: 20
        },
        end: {
          line: 606,
          column: 63
        }
      },
      '296': {
        start: {
          line: 607,
          column: 6
        },
        end: {
          line: 609,
          column: 7
        }
      },
      '297': {
        start: {
          line: 608,
          column: 8
        },
        end: {
          line: 608,
          column: 55
        }
      },
      '298': {
        start: {
          line: 615,
          column: 2
        },
        end: {
          line: 618,
          column: 5
        }
      },
      '299': {
        start: {
          line: 616,
          column: 4
        },
        end: {
          line: 616,
          column: 27
        }
      },
      '300': {
        start: {
          line: 617,
          column: 4
        },
        end: {
          line: 617,
          column: 29
        }
      },
      '301': {
        start: {
          line: 620,
          column: 19
        },
        end: {
          line: 625,
          column: 4
        }
      },
      '302': {
        start: {
          line: 626,
          column: 2
        },
        end: {
          line: 637,
          column: 4
        }
      },
      '303': {
        start: {
          line: 627,
          column: 4
        },
        end: {
          line: 627,
          column: 42
        }
      },
      '304': {
        start: {
          line: 628,
          column: 4
        },
        end: {
          line: 628,
          column: 70
        }
      },
      '305': {
        start: {
          line: 629,
          column: 4
        },
        end: {
          line: 634,
          column: 5
        }
      },
      '306': {
        start: {
          line: 630,
          column: 6
        },
        end: {
          line: 633,
          column: 7
        }
      },
      '307': {
        start: {
          line: 631,
          column: 8
        },
        end: {
          line: 631,
          column: 46
        }
      },
      '308': {
        start: {
          line: 632,
          column: 8
        },
        end: {
          line: 632,
          column: 14
        }
      },
      '309': {
        start: {
          line: 636,
          column: 4
        },
        end: {
          line: 636,
          column: 22
        }
      },
      '310': {
        start: {
          line: 638,
          column: 2
        },
        end: {
          line: 646,
          column: 4
        }
      },
      '311': {
        start: {
          line: 639,
          column: 4
        },
        end: {
          line: 645,
          column: 5
        }
      },
      '312': {
        start: {
          line: 640,
          column: 6
        },
        end: {
          line: 644,
          column: 7
        }
      },
      '313': {
        start: {
          line: 641,
          column: 8
        },
        end: {
          line: 641,
          column: 53
        }
      },
      '314': {
        start: {
          line: 642,
          column: 8
        },
        end: {
          line: 642,
          column: 51
        }
      },
      '315': {
        start: {
          line: 643,
          column: 8
        },
        end: {
          line: 643,
          column: 14
        }
      },
      '316': {
        start: {
          line: 647,
          column: 2
        },
        end: {
          line: 649,
          column: 4
        }
      },
      '317': {
        start: {
          line: 648,
          column: 4
        },
        end: {
          line: 648,
          column: 43
        }
      },
      '318': {
        start: {
          line: 653,
          column: 2
        },
        end: {
          line: 663,
          column: 4
        }
      },
      '319': {
        start: {
          line: 654,
          column: 25
        },
        end: {
          line: 654,
          column: 49
        }
      },
      '320': {
        start: {
          line: 655,
          column: 17
        },
        end: {
          line: 655,
          column: 91
        }
      },
      '321': {
        start: {
          line: 656,
          column: 4
        },
        end: {
          line: 660,
          column: 5
        }
      },
      '322': {
        start: {
          line: 657,
          column: 6
        },
        end: {
          line: 657,
          column: 16
        }
      },
      '323': {
        start: {
          line: 658,
          column: 6
        },
        end: {
          line: 658,
          column: 31
        }
      },
      '324': {
        start: {
          line: 659,
          column: 6
        },
        end: {
          line: 659,
          column: 13
        }
      },
      '325': {
        start: {
          line: 661,
          column: 4
        },
        end: {
          line: 661,
          column: 32
        }
      },
      '326': {
        start: {
          line: 662,
          column: 4
        },
        end: {
          line: 662,
          column: 40
        }
      },
      '327': {
        start: {
          line: 664,
          column: 2
        },
        end: {
          line: 666,
          column: 4
        }
      },
      '328': {
        start: {
          line: 665,
          column: 4
        },
        end: {
          line: 665,
          column: 40
        }
      },
      '329': {
        start: {
          line: 669,
          column: 2
        },
        end: {
          line: 679,
          column: 4
        }
      },
      '330': {
        start: {
          line: 670,
          column: 25
        },
        end: {
          line: 670,
          column: 49
        }
      },
      '331': {
        start: {
          line: 671,
          column: 17
        },
        end: {
          line: 671,
          column: 91
        }
      },
      '332': {
        start: {
          line: 672,
          column: 4
        },
        end: {
          line: 676,
          column: 5
        }
      },
      '333': {
        start: {
          line: 673,
          column: 6
        },
        end: {
          line: 673,
          column: 16
        }
      },
      '334': {
        start: {
          line: 674,
          column: 6
        },
        end: {
          line: 674,
          column: 31
        }
      },
      '335': {
        start: {
          line: 675,
          column: 6
        },
        end: {
          line: 675,
          column: 13
        }
      },
      '336': {
        start: {
          line: 677,
          column: 4
        },
        end: {
          line: 677,
          column: 32
        }
      },
      '337': {
        start: {
          line: 678,
          column: 4
        },
        end: {
          line: 678,
          column: 40
        }
      },
      '338': {
        start: {
          line: 680,
          column: 2
        },
        end: {
          line: 682,
          column: 4
        }
      },
      '339': {
        start: {
          line: 681,
          column: 4
        },
        end: {
          line: 681,
          column: 40
        }
      },
      '340': {
        start: {
          line: 686,
          column: 2
        },
        end: {
          line: 689,
          column: 4
        }
      },
      '341': {
        start: {
          line: 687,
          column: 4
        },
        end: {
          line: 687,
          column: 32
        }
      },
      '342': {
        start: {
          line: 688,
          column: 4
        },
        end: {
          line: 688,
          column: 40
        }
      },
      '343': {
        start: {
          line: 690,
          column: 2
        },
        end: {
          line: 692,
          column: 4
        }
      },
      '344': {
        start: {
          line: 691,
          column: 4
        },
        end: {
          line: 691,
          column: 40
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 61
          },
          end: {
            line: 1,
            column: 62
          }
        },
        loc: {
          start: {
            line: 1,
            column: 263
          },
          end: {
            line: 650,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 9,
            column: 25
          }
        },
        loc: {
          start: {
            line: 9,
            column: 40
          },
          end: {
            line: 12,
            column: 3
          }
        },
        line: 9
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 13,
            column: 20
          },
          end: {
            line: 13,
            column: 21
          }
        },
        loc: {
          start: {
            line: 13,
            column: 32
          },
          end: {
            line: 16,
            column: 3
          }
        },
        line: 13
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 18,
            column: 28
          },
          end: {
            line: 18,
            column: 29
          }
        },
        loc: {
          start: {
            line: 18,
            column: 44
          },
          end: {
            line: 33,
            column: 3
          }
        },
        line: 18
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 34,
            column: 25
          },
          end: {
            line: 34,
            column: 26
          }
        },
        loc: {
          start: {
            line: 34,
            column: 42
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 34
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 55,
            column: 22
          },
          end: {
            line: 55,
            column: 23
          }
        },
        loc: {
          start: {
            line: 55,
            column: 39
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 55
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 65,
            column: 121
          },
          end: {
            line: 65,
            column: 122
          }
        },
        loc: {
          start: {
            line: 65,
            column: 126
          },
          end: {
            line: 68,
            column: 7
          }
        },
        line: 65
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 190,
            column: 46
          },
          end: {
            line: 190,
            column: 47
          }
        },
        loc: {
          start: {
            line: 190,
            column: 54
          },
          end: {
            line: 197,
            column: 7
          }
        },
        line: 190
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 191,
            column: 39
          },
          end: {
            line: 191,
            column: 40
          }
        },
        loc: {
          start: {
            line: 191,
            column: 47
          },
          end: {
            line: 194,
            column: 9
          }
        },
        line: 191
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 227,
            column: 9
          },
          end: {
            line: 227,
            column: 10
          }
        },
        loc: {
          start: {
            line: 227,
            column: 22
          },
          end: {
            line: 236,
            column: 7
          }
        },
        line: 227
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 232,
            column: 64
          },
          end: {
            line: 232,
            column: 65
          }
        },
        loc: {
          start: {
            line: 232,
            column: 72
          },
          end: {
            line: 235,
            column: 9
          }
        },
        line: 232
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 289,
            column: 15
          },
          end: {
            line: 289,
            column: 16
          }
        },
        loc: {
          start: {
            line: 289,
            column: 28
          },
          end: {
            line: 303,
            column: 13
          }
        },
        line: 289
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 299,
            column: 81
          },
          end: {
            line: 299,
            column: 82
          }
        },
        loc: {
          start: {
            line: 299,
            column: 89
          },
          end: {
            line: 302,
            column: 15
          }
        },
        line: 299
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 311,
            column: 73
          },
          end: {
            line: 311,
            column: 74
          }
        },
        loc: {
          start: {
            line: 311,
            column: 81
          },
          end: {
            line: 314,
            column: 7
          }
        },
        line: 311
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 355,
            column: 62
          },
          end: {
            line: 355,
            column: 63
          }
        },
        loc: {
          start: {
            line: 355,
            column: 70
          },
          end: {
            line: 386,
            column: 7
          }
        },
        line: 355
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 375,
            column: 56
          },
          end: {
            line: 375,
            column: 57
          }
        },
        loc: {
          start: {
            line: 375,
            column: 64
          },
          end: {
            line: 377,
            column: 11
          }
        },
        line: 375
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 379,
            column: 57
          },
          end: {
            line: 379,
            column: 58
          }
        },
        loc: {
          start: {
            line: 379,
            column: 65
          },
          end: {
            line: 381,
            column: 11
          }
        },
        line: 379
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 393,
            column: 64
          },
          end: {
            line: 393,
            column: 65
          }
        },
        loc: {
          start: {
            line: 393,
            column: 72
          },
          end: {
            line: 414,
            column: 9
          }
        },
        line: 393
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 615,
            column: 49
          },
          end: {
            line: 615,
            column: 50
          }
        },
        loc: {
          start: {
            line: 615,
            column: 57
          },
          end: {
            line: 618,
            column: 3
          }
        },
        line: 615
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 626,
            column: 31
          },
          end: {
            line: 626,
            column: 32
          }
        },
        loc: {
          start: {
            line: 626,
            column: 66
          },
          end: {
            line: 637,
            column: 3
          }
        },
        line: 626
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 638,
            column: 27
          },
          end: {
            line: 638,
            column: 28
          }
        },
        loc: {
          start: {
            line: 638,
            column: 74
          },
          end: {
            line: 646,
            column: 3
          }
        },
        line: 638
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 647,
            column: 25
          },
          end: {
            line: 647,
            column: 26
          }
        },
        loc: {
          start: {
            line: 647,
            column: 72
          },
          end: {
            line: 649,
            column: 3
          }
        },
        line: 647
      },
      '22': {
        name: 'customDatabaseDesign_edit',
        decl: {
          start: {
            line: 652,
            column: 9
          },
          end: {
            line: 652,
            column: 34
          }
        },
        loc: {
          start: {
            line: 652,
            column: 85
          },
          end: {
            line: 667,
            column: 1
          }
        },
        line: 652
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 653,
            column: 24
          },
          end: {
            line: 653,
            column: 25
          }
        },
        loc: {
          start: {
            line: 653,
            column: 36
          },
          end: {
            line: 663,
            column: 3
          }
        },
        line: 653
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 664,
            column: 22
          },
          end: {
            line: 664,
            column: 23
          }
        },
        loc: {
          start: {
            line: 664,
            column: 34
          },
          end: {
            line: 666,
            column: 3
          }
        },
        line: 664
      },
      '25': {
        name: 'customDatabaseDesign_subform',
        decl: {
          start: {
            line: 668,
            column: 9
          },
          end: {
            line: 668,
            column: 37
          }
        },
        loc: {
          start: {
            line: 668,
            column: 88
          },
          end: {
            line: 683,
            column: 1
          }
        },
        line: 668
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 669,
            column: 24
          },
          end: {
            line: 669,
            column: 25
          }
        },
        loc: {
          start: {
            line: 669,
            column: 36
          },
          end: {
            line: 679,
            column: 3
          }
        },
        line: 669
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 680,
            column: 22
          },
          end: {
            line: 680,
            column: 23
          }
        },
        loc: {
          start: {
            line: 680,
            column: 34
          },
          end: {
            line: 682,
            column: 3
          }
        },
        line: 680
      },
      '28': {
        name: 'customDatabaseDesign_editField',
        decl: {
          start: {
            line: 685,
            column: 9
          },
          end: {
            line: 685,
            column: 39
          }
        },
        loc: {
          start: {
            line: 685,
            column: 90
          },
          end: {
            line: 693,
            column: 1
          }
        },
        line: 685
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 686,
            column: 29
          },
          end: {
            line: 686,
            column: 30
          }
        },
        loc: {
          start: {
            line: 686,
            column: 41
          },
          end: {
            line: 689,
            column: 3
          }
        },
        line: 686
      },
      '30': {
        name: '(anonymous_30)',
        decl: {
          start: {
            line: 690,
            column: 22
          },
          end: {
            line: 690,
            column: 23
          }
        },
        loc: {
          start: {
            line: 690,
            column: 34
          },
          end: {
            line: 692,
            column: 3
          }
        },
        line: 690
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 5,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 5,
            column: 3
          }
        }, {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 5,
            column: 3
          }
        }],
        line: 3
      },
      '1': {
        loc: {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        }, {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        }],
        line: 71
      },
      '2': {
        loc: {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 89,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 89,
            column: 7
          }
        }, {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 89,
            column: 7
          }
        }],
        line: 87
      },
      '3': {
        loc: {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 94,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 94,
            column: 9
          }
        }, {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 94,
            column: 9
          }
        }],
        line: 92
      },
      '4': {
        loc: {
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 103,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 103,
            column: 9
          }
        }, {
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 103,
            column: 9
          }
        }],
        line: 99
      },
      '5': {
        loc: {
          start: {
            line: 100,
            column: 10
          },
          end: {
            line: 102,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 100,
            column: 10
          },
          end: {
            line: 102,
            column: 11
          }
        }, {
          start: {
            line: 100,
            column: 10
          },
          end: {
            line: 102,
            column: 11
          }
        }],
        line: 100
      },
      '6': {
        loc: {
          start: {
            line: 110,
            column: 10
          },
          end: {
            line: 112,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 110,
            column: 10
          },
          end: {
            line: 112,
            column: 11
          }
        }, {
          start: {
            line: 110,
            column: 10
          },
          end: {
            line: 112,
            column: 11
          }
        }],
        line: 110
      },
      '7': {
        loc: {
          start: {
            line: 123,
            column: 10
          },
          end: {
            line: 123,
            column: 82
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 123,
            column: 33
          },
          end: {
            line: 123,
            column: 73
          }
        }, {
          start: {
            line: 123,
            column: 77
          },
          end: {
            line: 123,
            column: 82
          }
        }],
        line: 123
      },
      '8': {
        loc: {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        }, {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        }],
        line: 125
      },
      '9': {
        loc: {
          start: {
            line: 126,
            column: 42
          },
          end: {
            line: 126,
            column: 74
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 126,
            column: 65
          },
          end: {
            line: 126,
            column: 68
          }
        }, {
          start: {
            line: 126,
            column: 71
          },
          end: {
            line: 126,
            column: 74
          }
        }],
        line: 126
      },
      '10': {
        loc: {
          start: {
            line: 143,
            column: 10
          },
          end: {
            line: 145,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 143,
            column: 10
          },
          end: {
            line: 145,
            column: 11
          }
        }, {
          start: {
            line: 143,
            column: 10
          },
          end: {
            line: 145,
            column: 11
          }
        }],
        line: 143
      },
      '11': {
        loc: {
          start: {
            line: 212,
            column: 6
          },
          end: {
            line: 215,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 212,
            column: 6
          },
          end: {
            line: 215,
            column: 7
          }
        }, {
          start: {
            line: 212,
            column: 6
          },
          end: {
            line: 215,
            column: 7
          }
        }],
        line: 212
      },
      '12': {
        loc: {
          start: {
            line: 228,
            column: 8
          },
          end: {
            line: 230,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 228,
            column: 8
          },
          end: {
            line: 230,
            column: 9
          }
        }, {
          start: {
            line: 228,
            column: 8
          },
          end: {
            line: 230,
            column: 9
          }
        }],
        line: 228
      },
      '13': {
        loc: {
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 251,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 251,
            column: 7
          }
        }, {
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 251,
            column: 7
          }
        }],
        line: 249
      },
      '14': {
        loc: {
          start: {
            line: 253,
            column: 8
          },
          end: {
            line: 257,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 253,
            column: 8
          },
          end: {
            line: 257,
            column: 9
          }
        }, {
          start: {
            line: 253,
            column: 8
          },
          end: {
            line: 257,
            column: 9
          }
        }],
        line: 253
      },
      '15': {
        loc: {
          start: {
            line: 253,
            column: 12
          },
          end: {
            line: 253,
            column: 65
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 253,
            column: 12
          },
          end: {
            line: 253,
            column: 24
          }
        }, {
          start: {
            line: 253,
            column: 29
          },
          end: {
            line: 253,
            column: 41
          }
        }, {
          start: {
            line: 253,
            column: 45
          },
          end: {
            line: 253,
            column: 64
          }
        }],
        line: 253
      },
      '16': {
        loc: {
          start: {
            line: 254,
            column: 10
          },
          end: {
            line: 256,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 254,
            column: 10
          },
          end: {
            line: 256,
            column: 11
          }
        }, {
          start: {
            line: 254,
            column: 10
          },
          end: {
            line: 256,
            column: 11
          }
        }],
        line: 254
      },
      '17': {
        loc: {
          start: {
            line: 273,
            column: 6
          },
          end: {
            line: 307,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 273,
            column: 6
          },
          end: {
            line: 307,
            column: 7
          }
        }, {
          start: {
            line: 273,
            column: 6
          },
          end: {
            line: 307,
            column: 7
          }
        }],
        line: 273
      },
      '18': {
        loc: {
          start: {
            line: 275,
            column: 8
          },
          end: {
            line: 306,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 275,
            column: 8
          },
          end: {
            line: 306,
            column: 9
          }
        }, {
          start: {
            line: 275,
            column: 8
          },
          end: {
            line: 306,
            column: 9
          }
        }],
        line: 275
      },
      '19': {
        loc: {
          start: {
            line: 278,
            column: 10
          },
          end: {
            line: 305,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 278,
            column: 10
          },
          end: {
            line: 305,
            column: 11
          }
        }, {
          start: {
            line: 278,
            column: 10
          },
          end: {
            line: 305,
            column: 11
          }
        }],
        line: 278
      },
      '20': {
        loc: {
          start: {
            line: 290,
            column: 14
          },
          end: {
            line: 292,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 290,
            column: 14
          },
          end: {
            line: 292,
            column: 15
          }
        }, {
          start: {
            line: 290,
            column: 14
          },
          end: {
            line: 292,
            column: 15
          }
        }],
        line: 290
      },
      '21': {
        loc: {
          start: {
            line: 320,
            column: 6
          },
          end: {
            line: 322,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 320,
            column: 6
          },
          end: {
            line: 322,
            column: 7
          }
        }, {
          start: {
            line: 320,
            column: 6
          },
          end: {
            line: 322,
            column: 7
          }
        }],
        line: 320
      },
      '22': {
        loc: {
          start: {
            line: 329,
            column: 8
          },
          end: {
            line: 333,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 329,
            column: 8
          },
          end: {
            line: 333,
            column: 9
          }
        }, {
          start: {
            line: 329,
            column: 8
          },
          end: {
            line: 333,
            column: 9
          }
        }],
        line: 329
      },
      '23': {
        loc: {
          start: {
            line: 338,
            column: 6
          },
          end: {
            line: 340,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 338,
            column: 6
          },
          end: {
            line: 340,
            column: 7
          }
        }, {
          start: {
            line: 338,
            column: 6
          },
          end: {
            line: 340,
            column: 7
          }
        }],
        line: 338
      },
      '24': {
        loc: {
          start: {
            line: 341,
            column: 6
          },
          end: {
            line: 347,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 341,
            column: 6
          },
          end: {
            line: 347,
            column: 7
          }
        }, {
          start: {
            line: 341,
            column: 6
          },
          end: {
            line: 347,
            column: 7
          }
        }],
        line: 341
      },
      '25': {
        loc: {
          start: {
            line: 349,
            column: 6
          },
          end: {
            line: 351,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 349,
            column: 6
          },
          end: {
            line: 351,
            column: 7
          }
        }, {
          start: {
            line: 349,
            column: 6
          },
          end: {
            line: 351,
            column: 7
          }
        }],
        line: 349
      },
      '26': {
        loc: {
          start: {
            line: 358,
            column: 8
          },
          end: {
            line: 360,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 358,
            column: 8
          },
          end: {
            line: 360,
            column: 9
          }
        }, {
          start: {
            line: 358,
            column: 8
          },
          end: {
            line: 360,
            column: 9
          }
        }],
        line: 358
      },
      '27': {
        loc: {
          start: {
            line: 362,
            column: 8
          },
          end: {
            line: 364,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 362,
            column: 8
          },
          end: {
            line: 364,
            column: 9
          }
        }, {
          start: {
            line: 362,
            column: 8
          },
          end: {
            line: 364,
            column: 9
          }
        }],
        line: 362
      },
      '28': {
        loc: {
          start: {
            line: 370,
            column: 10
          },
          end: {
            line: 372,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 370,
            column: 10
          },
          end: {
            line: 372,
            column: 11
          }
        }, {
          start: {
            line: 370,
            column: 10
          },
          end: {
            line: 372,
            column: 11
          }
        }],
        line: 370
      },
      '29': {
        loc: {
          start: {
            line: 391,
            column: 6
          },
          end: {
            line: 416,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 391,
            column: 6
          },
          end: {
            line: 416,
            column: 7
          }
        }, {
          start: {
            line: 391,
            column: 6
          },
          end: {
            line: 416,
            column: 7
          }
        }],
        line: 391
      },
      '30': {
        loc: {
          start: {
            line: 397,
            column: 10
          },
          end: {
            line: 399,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 397,
            column: 10
          },
          end: {
            line: 399,
            column: 11
          }
        }, {
          start: {
            line: 397,
            column: 10
          },
          end: {
            line: 399,
            column: 11
          }
        }],
        line: 397
      },
      '31': {
        loc: {
          start: {
            line: 406,
            column: 12
          },
          end: {
            line: 408,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 406,
            column: 12
          },
          end: {
            line: 408,
            column: 13
          }
        }, {
          start: {
            line: 406,
            column: 12
          },
          end: {
            line: 408,
            column: 13
          }
        }],
        line: 406
      },
      '32': {
        loc: {
          start: {
            line: 418,
            column: 6
          },
          end: {
            line: 420,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 418,
            column: 6
          },
          end: {
            line: 420,
            column: 7
          }
        }, {
          start: {
            line: 418,
            column: 6
          },
          end: {
            line: 420,
            column: 7
          }
        }],
        line: 418
      },
      '33': {
        loc: {
          start: {
            line: 445,
            column: 6
          },
          end: {
            line: 447,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 445,
            column: 6
          },
          end: {
            line: 447,
            column: 7
          }
        }, {
          start: {
            line: 445,
            column: 6
          },
          end: {
            line: 447,
            column: 7
          }
        }],
        line: 445
      },
      '34': {
        loc: {
          start: {
            line: 449,
            column: 8
          },
          end: {
            line: 454,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 449,
            column: 8
          },
          end: {
            line: 454,
            column: 9
          }
        }, {
          start: {
            line: 449,
            column: 8
          },
          end: {
            line: 454,
            column: 9
          }
        }],
        line: 449
      },
      '35': {
        loc: {
          start: {
            line: 460,
            column: 6
          },
          end: {
            line: 464,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 460,
            column: 6
          },
          end: {
            line: 464,
            column: 7
          }
        }, {
          start: {
            line: 460,
            column: 6
          },
          end: {
            line: 464,
            column: 7
          }
        }],
        line: 460
      },
      '36': {
        loc: {
          start: {
            line: 461,
            column: 8
          },
          end: {
            line: 463,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 461,
            column: 8
          },
          end: {
            line: 463,
            column: 9
          }
        }, {
          start: {
            line: 461,
            column: 8
          },
          end: {
            line: 463,
            column: 9
          }
        }],
        line: 461
      },
      '37': {
        loc: {
          start: {
            line: 476,
            column: 8
          },
          end: {
            line: 478,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 476,
            column: 8
          },
          end: {
            line: 478,
            column: 9
          }
        }, {
          start: {
            line: 476,
            column: 8
          },
          end: {
            line: 478,
            column: 9
          }
        }],
        line: 476
      },
      '38': {
        loc: {
          start: {
            line: 480,
            column: 6
          },
          end: {
            line: 482,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 480,
            column: 6
          },
          end: {
            line: 482,
            column: 7
          }
        }, {
          start: {
            line: 480,
            column: 6
          },
          end: {
            line: 482,
            column: 7
          }
        }],
        line: 480
      },
      '39': {
        loc: {
          start: {
            line: 485,
            column: 6
          },
          end: {
            line: 490,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 485,
            column: 6
          },
          end: {
            line: 490,
            column: 7
          }
        }, {
          start: {
            line: 485,
            column: 6
          },
          end: {
            line: 490,
            column: 7
          }
        }],
        line: 485
      },
      '40': {
        loc: {
          start: {
            line: 487,
            column: 8
          },
          end: {
            line: 489,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 487,
            column: 8
          },
          end: {
            line: 489,
            column: 9
          }
        }, {
          start: {
            line: 487,
            column: 8
          },
          end: {
            line: 489,
            column: 9
          }
        }],
        line: 487
      },
      '41': {
        loc: {
          start: {
            line: 491,
            column: 24
          },
          end: {
            line: 491,
            column: 83
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 491,
            column: 24
          },
          end: {
            line: 491,
            column: 72
          }
        }, {
          start: {
            line: 491,
            column: 76
          },
          end: {
            line: 491,
            column: 83
          }
        }],
        line: 491
      },
      '42': {
        loc: {
          start: {
            line: 506,
            column: 6
          },
          end: {
            line: 509,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 506,
            column: 6
          },
          end: {
            line: 509,
            column: 7
          }
        }, {
          start: {
            line: 506,
            column: 6
          },
          end: {
            line: 509,
            column: 7
          }
        }],
        line: 506
      },
      '43': {
        loc: {
          start: {
            line: 524,
            column: 8
          },
          end: {
            line: 526,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 524,
            column: 8
          },
          end: {
            line: 526,
            column: 9
          }
        }, {
          start: {
            line: 524,
            column: 8
          },
          end: {
            line: 526,
            column: 9
          }
        }],
        line: 524
      },
      '44': {
        loc: {
          start: {
            line: 528,
            column: 10
          },
          end: {
            line: 531,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 528,
            column: 10
          },
          end: {
            line: 531,
            column: 11
          }
        }, {
          start: {
            line: 528,
            column: 10
          },
          end: {
            line: 531,
            column: 11
          }
        }],
        line: 528
      },
      '45': {
        loc: {
          start: {
            line: 540,
            column: 6
          },
          end: {
            line: 554,
            column: 7
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 541,
            column: 8
          },
          end: {
            line: 541,
            column: 15
          }
        }, {
          start: {
            line: 541,
            column: 16
          },
          end: {
            line: 541,
            column: 23
          }
        }, {
          start: {
            line: 541,
            column: 24
          },
          end: {
            line: 543,
            column: 16
          }
        }, {
          start: {
            line: 544,
            column: 8
          },
          end: {
            line: 546,
            column: 16
          }
        }, {
          start: {
            line: 547,
            column: 8
          },
          end: {
            line: 549,
            column: 16
          }
        }, {
          start: {
            line: 550,
            column: 8
          },
          end: {
            line: 552,
            column: 16
          }
        }, {
          start: {
            line: 553,
            column: 8
          },
          end: {
            line: 553,
            column: 16
          }
        }],
        line: 540
      },
      '46': {
        loc: {
          start: {
            line: 558,
            column: 6
          },
          end: {
            line: 560,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 558,
            column: 6
          },
          end: {
            line: 560,
            column: 7
          }
        }, {
          start: {
            line: 558,
            column: 6
          },
          end: {
            line: 560,
            column: 7
          }
        }],
        line: 558
      },
      '47': {
        loc: {
          start: {
            line: 575,
            column: 6
          },
          end: {
            line: 577,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 575,
            column: 6
          },
          end: {
            line: 577,
            column: 7
          }
        }, {
          start: {
            line: 575,
            column: 6
          },
          end: {
            line: 577,
            column: 7
          }
        }],
        line: 575
      },
      '48': {
        loc: {
          start: {
            line: 580,
            column: 6
          },
          end: {
            line: 584,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 580,
            column: 6
          },
          end: {
            line: 584,
            column: 7
          }
        }, {
          start: {
            line: 580,
            column: 6
          },
          end: {
            line: 584,
            column: 7
          }
        }],
        line: 580
      },
      '49': {
        loc: {
          start: {
            line: 580,
            column: 10
          },
          end: {
            line: 580,
            column: 101
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 580,
            column: 10
          },
          end: {
            line: 580,
            column: 27
          }
        }, {
          start: {
            line: 580,
            column: 31
          },
          end: {
            line: 580,
            column: 67
          }
        }, {
          start: {
            line: 580,
            column: 71
          },
          end: {
            line: 580,
            column: 101
          }
        }],
        line: 580
      },
      '50': {
        loc: {
          start: {
            line: 586,
            column: 6
          },
          end: {
            line: 588,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 586,
            column: 6
          },
          end: {
            line: 588,
            column: 7
          }
        }, {
          start: {
            line: 586,
            column: 6
          },
          end: {
            line: 588,
            column: 7
          }
        }],
        line: 586
      },
      '51': {
        loc: {
          start: {
            line: 591,
            column: 6
          },
          end: {
            line: 593,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 591,
            column: 6
          },
          end: {
            line: 593,
            column: 7
          }
        }, {
          start: {
            line: 591,
            column: 6
          },
          end: {
            line: 593,
            column: 7
          }
        }],
        line: 591
      },
      '52': {
        loc: {
          start: {
            line: 594,
            column: 6
          },
          end: {
            line: 596,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 594,
            column: 6
          },
          end: {
            line: 596,
            column: 7
          }
        }, {
          start: {
            line: 594,
            column: 6
          },
          end: {
            line: 596,
            column: 7
          }
        }],
        line: 594
      },
      '53': {
        loc: {
          start: {
            line: 599,
            column: 6
          },
          end: {
            line: 601,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 599,
            column: 6
          },
          end: {
            line: 601,
            column: 7
          }
        }, {
          start: {
            line: 599,
            column: 6
          },
          end: {
            line: 601,
            column: 7
          }
        }],
        line: 599
      },
      '54': {
        loc: {
          start: {
            line: 607,
            column: 6
          },
          end: {
            line: 609,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 607,
            column: 6
          },
          end: {
            line: 609,
            column: 7
          }
        }, {
          start: {
            line: 607,
            column: 6
          },
          end: {
            line: 609,
            column: 7
          }
        }],
        line: 607
      },
      '55': {
        loc: {
          start: {
            line: 630,
            column: 6
          },
          end: {
            line: 633,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 630,
            column: 6
          },
          end: {
            line: 633,
            column: 7
          }
        }, {
          start: {
            line: 630,
            column: 6
          },
          end: {
            line: 633,
            column: 7
          }
        }],
        line: 630
      },
      '56': {
        loc: {
          start: {
            line: 640,
            column: 6
          },
          end: {
            line: 644,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 640,
            column: 6
          },
          end: {
            line: 644,
            column: 7
          }
        }, {
          start: {
            line: 640,
            column: 6
          },
          end: {
            line: 644,
            column: 7
          }
        }],
        line: 640
      },
      '57': {
        loc: {
          start: {
            line: 656,
            column: 4
          },
          end: {
            line: 660,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 656,
            column: 4
          },
          end: {
            line: 660,
            column: 5
          }
        }, {
          start: {
            line: 656,
            column: 4
          },
          end: {
            line: 660,
            column: 5
          }
        }],
        line: 656
      },
      '58': {
        loc: {
          start: {
            line: 656,
            column: 8
          },
          end: {
            line: 656,
            column: 42
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 656,
            column: 8
          },
          end: {
            line: 656,
            column: 12
          }
        }, {
          start: {
            line: 656,
            column: 16
          },
          end: {
            line: 656,
            column: 42
          }
        }],
        line: 656
      },
      '59': {
        loc: {
          start: {
            line: 672,
            column: 4
          },
          end: {
            line: 676,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 672,
            column: 4
          },
          end: {
            line: 676,
            column: 5
          }
        }, {
          start: {
            line: 672,
            column: 4
          },
          end: {
            line: 676,
            column: 5
          }
        }],
        line: 672
      },
      '60': {
        loc: {
          start: {
            line: 672,
            column: 8
          },
          end: {
            line: 672,
            column: 42
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 672,
            column: 8
          },
          end: {
            line: 672,
            column: 12
          }
        }, {
          start: {
            line: 672,
            column: 16
          },
          end: {
            line: 672,
            column: 42
          }
        }],
        line: 672
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0,
      '189': 0,
      '190': 0,
      '191': 0,
      '192': 0,
      '193': 0,
      '194': 0,
      '195': 0,
      '196': 0,
      '197': 0,
      '198': 0,
      '199': 0,
      '200': 0,
      '201': 0,
      '202': 0,
      '203': 0,
      '204': 0,
      '205': 0,
      '206': 0,
      '207': 0,
      '208': 0,
      '209': 0,
      '210': 0,
      '211': 0,
      '212': 0,
      '213': 0,
      '214': 0,
      '215': 0,
      '216': 0,
      '217': 0,
      '218': 0,
      '219': 0,
      '220': 0,
      '221': 0,
      '222': 0,
      '223': 0,
      '224': 0,
      '225': 0,
      '226': 0,
      '227': 0,
      '228': 0,
      '229': 0,
      '230': 0,
      '231': 0,
      '232': 0,
      '233': 0,
      '234': 0,
      '235': 0,
      '236': 0,
      '237': 0,
      '238': 0,
      '239': 0,
      '240': 0,
      '241': 0,
      '242': 0,
      '243': 0,
      '244': 0,
      '245': 0,
      '246': 0,
      '247': 0,
      '248': 0,
      '249': 0,
      '250': 0,
      '251': 0,
      '252': 0,
      '253': 0,
      '254': 0,
      '255': 0,
      '256': 0,
      '257': 0,
      '258': 0,
      '259': 0,
      '260': 0,
      '261': 0,
      '262': 0,
      '263': 0,
      '264': 0,
      '265': 0,
      '266': 0,
      '267': 0,
      '268': 0,
      '269': 0,
      '270': 0,
      '271': 0,
      '272': 0,
      '273': 0,
      '274': 0,
      '275': 0,
      '276': 0,
      '277': 0,
      '278': 0,
      '279': 0,
      '280': 0,
      '281': 0,
      '282': 0,
      '283': 0,
      '284': 0,
      '285': 0,
      '286': 0,
      '287': 0,
      '288': 0,
      '289': 0,
      '290': 0,
      '291': 0,
      '292': 0,
      '293': 0,
      '294': 0,
      '295': 0,
      '296': 0,
      '297': 0,
      '298': 0,
      '299': 0,
      '300': 0,
      '301': 0,
      '302': 0,
      '303': 0,
      '304': 0,
      '305': 0,
      '306': 0,
      '307': 0,
      '308': 0,
      '309': 0,
      '310': 0,
      '311': 0,
      '312': 0,
      '313': 0,
      '314': 0,
      '315': 0,
      '316': 0,
      '317': 0,
      '318': 0,
      '319': 0,
      '320': 0,
      '321': 0,
      '322': 0,
      '323': 0,
      '324': 0,
      '325': 0,
      '326': 0,
      '327': 0,
      '328': 0,
      '329': 0,
      '330': 0,
      '331': 0,
      '332': 0,
      '333': 0,
      '334': 0,
      '335': 0,
      '336': 0,
      '337': 0,
      '338': 0,
      '339': 0,
      '340': 0,
      '341': 0,
      '342': 0,
      '343': 0,
      '344': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0],
      '41': [0, 0],
      '42': [0, 0],
      '43': [0, 0],
      '44': [0, 0],
      '45': [0, 0, 0, 0, 0, 0, 0],
      '46': [0, 0],
      '47': [0, 0],
      '48': [0, 0],
      '49': [0, 0, 0],
      '50': [0, 0],
      '51': [0, 0],
      '52': [0, 0],
      '53': [0, 0],
      '54': [0, 0],
      '55': [0, 0],
      '56': [0, 0],
      '57': [0, 0],
      '58': [0, 0],
      '59': [0, 0],
      '60': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_1hl321vx4v.s[0]++;
angular.module('app').controller('customDatabaseDesignCtrl', function ($scope, $deltaLocation, $log, $deltaPlanLogique, $sce, $deltahttp, $window, $deltaUnite, $deltaActor, $rootScope, $CRUDService, $filter, $translate, $uibModal, FileUploader, SweetAlert, $deltadate) {
  cov_1hl321vx4v.f[0]++;
  cov_1hl321vx4v.s[1]++;

  $rootScope.processPageRight('6_1');
  cov_1hl321vx4v.s[2]++;
  if ($rootScope.global_access_page_denied) {
    cov_1hl321vx4v.b[0][0]++;
    cov_1hl321vx4v.s[3]++;

    return;
  } else {
    cov_1hl321vx4v.b[0][1]++;
  }
  cov_1hl321vx4v.s[4]++;
  $scope.currentUser = $deltahttp.idUser;
  var PATH = (cov_1hl321vx4v.s[5]++, 'Formular');
  var KEY_DISPLAY = (cov_1hl321vx4v.s[6]++, 'KEY_DISPLAY_CUSTOM_DATA');
  cov_1hl321vx4v.s[7]++;
  $scope.openWorkflow = function (item) {
    cov_1hl321vx4v.f[1]++;
    cov_1hl321vx4v.s[8]++;

    $scope.selectedItem = item;
    cov_1hl321vx4v.s[9]++;
    $scope.view = 5;
  };
  cov_1hl321vx4v.s[10]++;
  var getLastId = function getLastId() {
    cov_1hl321vx4v.f[2]++;

    var d = (cov_1hl321vx4v.s[11]++, new Date().getTime().toString());
    cov_1hl321vx4v.s[12]++;
    return 'I' + d.substr(d.length - 5);
  };

  cov_1hl321vx4v.s[13]++;
  var openeditfomulaire = function openeditfomulaire(item) {
    cov_1hl321vx4v.f[3]++;
    cov_1hl321vx4v.s[14]++;


    $scope.formular.editItem = item;
    cov_1hl321vx4v.s[15]++;
    $scope.formular.editField();
  };
  cov_1hl321vx4v.s[16]++;
  $scope.getDateFormat = function (label) {
    cov_1hl321vx4v.f[4]++;
    cov_1hl321vx4v.s[17]++;

    return $deltadate.getCodeDate(label)[$rootScope.language.id];
  };
  cov_1hl321vx4v.s[18]++;
  $scope.selectedForm = null;
  cov_1hl321vx4v.s[19]++;
  $scope.listProjets = [{
    id: 'unites',
    name: $translate.instant('MENU.UN')
  }, {
    id: 'actors',
    name: $translate.instant('FN_ACTORS.LST_AC')
  }, {
    id: 'location',
    name: $translate.instant('MENU.P_G')
  }, {
    id: 'planlogique'
  }, {
    id: 'aggregate',
    name: $translate.instant('MENU.C_I')
  }];

  cov_1hl321vx4v.s[20]++;
  $scope.view = 1;
  cov_1hl321vx4v.s[21]++;
  $scope.setLoading = function (value) {
    cov_1hl321vx4v.f[5]++;
    cov_1hl321vx4v.s[22]++;

    $scope.isloading = value;
  };

  cov_1hl321vx4v.s[23]++;
  $scope.right = {
    validate: function validate() {
      var data = (cov_1hl321vx4v.s[24]++, {});
      cov_1hl321vx4v.s[25]++;

      $CRUDService.save(PATH, { action: 'MiseAJour_right', valeur: $scope.right.profil, id: $scope.formular.editItem.id }, function (d) {
        cov_1hl321vx4v.f[6]++;
        cov_1hl321vx4v.s[26]++;

        $scope.formular.editItem.RIGHT_ = $scope.right.profil;
        cov_1hl321vx4v.s[27]++;
        $scope.view = 1;
      });
    },
    changeConsultation: function changeConsultation(id) {
      cov_1hl321vx4v.s[28]++;

      if (!$scope.right.profil[id][0]) {
        cov_1hl321vx4v.b[1][0]++;
        cov_1hl321vx4v.s[29]++;

        $scope.right.profil[id][1] = false;
        cov_1hl321vx4v.s[30]++;
        $scope.right.profil[id][2] = false;
      } else {
        cov_1hl321vx4v.b[1][1]++;
      }
    }
  };

  var currentDate = (cov_1hl321vx4v.s[31]++, Date.newDate().getTime());
  cov_1hl321vx4v.s[32]++;
  $scope.formular = {
    labelTampon: '',
    isOngletEdit: false,
    indexEdit: 0,
    openRight: function openRight(item) {
      cov_1hl321vx4v.s[33]++;

      $scope.right.profil = {};
      cov_1hl321vx4v.s[34]++;
      $scope.view = 4;
      cov_1hl321vx4v.s[35]++;
      this.editItem = item;
      cov_1hl321vx4v.s[36]++;
      if (!item.RIGHT_) {
        cov_1hl321vx4v.b[2][0]++;
        cov_1hl321vx4v.s[37]++;

        item.RIGHT_ = {};
      } else {
        cov_1hl321vx4v.b[2][1]++;
      }
      cov_1hl321vx4v.s[38]++;
      $scope.right.listUser = [];
      cov_1hl321vx4v.s[39]++;
      for (var _iterator = $scope.dataUser, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var el = _ref;
        cov_1hl321vx4v.s[40]++;

        if (el.id == item.IDUSER) {
          cov_1hl321vx4v.b[3][0]++;
          cov_1hl321vx4v.s[41]++;

          continue;
        } else {
          cov_1hl321vx4v.b[3][1]++;
        }
        cov_1hl321vx4v.s[42]++;
        $scope.right.listUser.push(el);
      }
      cov_1hl321vx4v.s[43]++;
      for (var _iterator2 = $scope.right.listUser, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var _el = _ref2;
        cov_1hl321vx4v.s[44]++;

        $scope.right.profil[_el.id] = { m: { v: false, ed: false }, d: { v: false, ed: false } };
        cov_1hl321vx4v.s[45]++;
        if (item.RIGHT_[_el.id]) {
          cov_1hl321vx4v.b[4][0]++;
          cov_1hl321vx4v.s[46]++;

          if (!angular.isArray(item.RIGHT_[_el.id])) {
            cov_1hl321vx4v.b[5][0]++;
            cov_1hl321vx4v.s[47]++;

            $scope.right.profil[_el.id] = item.RIGHT_[_el.id];
          } else {
            cov_1hl321vx4v.b[5][1]++;
          }
        } else {
          cov_1hl321vx4v.b[4][1]++;
        }
      }
    },
    getLastId: function getLastId() {
      var id = (cov_1hl321vx4v.s[48]++, 'I0');
      cov_1hl321vx4v.s[49]++;
      for (var key in $scope.formular.editItem.STRUCTURE) {
        cov_1hl321vx4v.s[50]++;

        for (var _iterator3 = $scope.formular.editItem.STRUCTURE[key], _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
          var _ref3;

          if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref3 = _iterator3[_i3++];
          } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref3 = _i3.value;
          }

          var item = _ref3;
          cov_1hl321vx4v.s[51]++;

          if (item.id > id) {
            cov_1hl321vx4v.b[6][0]++;
            cov_1hl321vx4v.s[52]++;

            id = item.id;
          } else {
            cov_1hl321vx4v.b[6][1]++;
          }
        }
      }

      cov_1hl321vx4v.s[53]++;
      id = parseInt(id.replace('I', ''), 10);
      cov_1hl321vx4v.s[54]++;
      id += 1;
      cov_1hl321vx4v.s[55]++;
      id = 'I' + id;
    },
    hasSubForm: function hasSubForm(item) {
      cov_1hl321vx4v.s[56]++;

      return $filter('filter')(item.STRUCTURE, { type: 12 }, true).length > 0;
    },

    list: window.localStorage ? (cov_1hl321vx4v.b[7][0]++, localStorage.getItem(KEY_DISPLAY) == '1') : (cov_1hl321vx4v.b[7][1]++, false),
    changeDisplay: function changeDisplay() {
      cov_1hl321vx4v.s[57]++;

      if (window.localStorage) {
        cov_1hl321vx4v.b[8][0]++;
        cov_1hl321vx4v.s[58]++;

        localStorage.setItem(KEY_DISPLAY, $scope.formular.list ? (cov_1hl321vx4v.b[9][0]++, '1') : (cov_1hl321vx4v.b[9][1]++, '0'));
      } else {
        cov_1hl321vx4v.b[8][1]++;
      }
    },
    copiedItem: function copiedItem(item) {
      cov_1hl321vx4v.s[59]++;

      this.editItem.LAST_ID = getLastId();cov_1hl321vx4v.s[60]++;

      item.o = this.indexEdit;
    },
    startDrag: function startDrag(item, target) {
      cov_1hl321vx4v.s[61]++;

      for (var _iterator4 = this.listItem, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray4) {
          if (_i4 >= _iterator4.length) break;
          _ref4 = _iterator4[_i4++];
        } else {
          _i4 = _iterator4.next();
          if (_i4.done) break;
          _ref4 = _i4.value;
        }

        var el = _ref4;
        cov_1hl321vx4v.s[62]++;

        el.id = getLastId();
        cov_1hl321vx4v.s[63]++;
        el.o = this.indexEdit;
      }
    },
    changeMain: function changeMain(id) {
      cov_1hl321vx4v.s[64]++;

      $scope.formular.editItem.MAIN = id;
      cov_1hl321vx4v.s[65]++;
      for (var _iterator5 = formular.editItem.TAB_FORM, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
        var _ref5;

        if (_isArray5) {
          if (_i5 >= _iterator5.length) break;
          _ref5 = _iterator5[_i5++];
        } else {
          _i5 = _iterator5.next();
          if (_i5.done) break;
          _ref5 = _i5.value;
        }

        var strut = _ref5;
        cov_1hl321vx4v.s[66]++;

        for (var _iterator6 = $scope.formular.editItem.STRUCTURE[strut.id], _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
          var _ref6;

          if (_isArray6) {
            if (_i6 >= _iterator6.length) break;
            _ref6 = _iterator6[_i6++];
          } else {
            _i6 = _iterator6.next();
            if (_i6.done) break;
            _ref6 = _i6.value;
          }

          var el = _ref6;
          cov_1hl321vx4v.s[67]++;

          if (el.id == id) {
            cov_1hl321vx4v.b[10][0]++;
            cov_1hl321vx4v.s[68]++;

            continue;
          } else {
            cov_1hl321vx4v.b[10][1]++;
          }
          cov_1hl321vx4v.s[69]++;
          el.main = false;
        }
      }
    },

    listItem: [{
      icon: 'text-width', label: $translate.instant('FORMULAR.FIELD.TEXT'), type: 1, format: 125, required: false, cols: true, id: getLastId()
    }, {
      icon: 'list-ol', label: $translate.instant('FORMULAR.FIELD.LIST'), type: 2, type_option: 1, optionp: 'unites', options: [], required: false, cols: true, id: getLastId()
    }, {
      icon: 'calendar', label: $translate.instant('FORMULAR.FIELD.DATE'), type: 3, format: 'mediumDate', required: false, cols: true, id: getLastId()
    }, {
      icon: 'calculator', label: $translate.instant('FORMULAR.FIELD.NUMBER'), type: 4, format: 2, required: false, cols: true, id: getLastId()
    }, {
      icon: 'dot-circle-o', label: $translate.instant('FORMULAR.FIELD.CHOISE'), type: 6, options: [], multi: false, required: false, cols: true, id: getLastId()
    }, {
      icon: 'image', label: $translate.instant('FORMULAR.FIELD.PICTURE'), type: 8, cols: true, id: getLastId()
    }, {
      icon: 'microphone', label: $translate.instant('FORMULAR.FIELD.AUDIO'), type: 10, cols: true, id: getLastId()
    }, {
      icon: 'map-marker', label: $translate.instant('FORMULAR.FIELD.LOCATION'), type: 11, cols: true, id: getLastId()
    }, {
      icon: 'object-group',
      label: $translate.instant('FORMULAR.FIELD.FORMULAR'),
      type: 12,
      cols: true,
      id: getLastId(),
      ITEM: 'record',
      ITEM_P: 'records',
      MAIN: '',
      NAME: '',
      IDUSER: $deltahttp.idUser,
      STRUCTURE: null,
      TAB_FORM: [{ id: getLastId(), l: '1' }]
    }],
    editList: [],
    getAll: function getAll() {
      cov_1hl321vx4v.s[70]++;

      $scope.isloading = true;
      cov_1hl321vx4v.s[71]++;
      $scope.listFormular = [];
      cov_1hl321vx4v.s[72]++;
      $CRUDService.getAll(PATH, { get: 'all' }, function (data) {
        cov_1hl321vx4v.f[7]++;
        cov_1hl321vx4v.s[73]++;

        $scope.listFormular = data.map(function (item) {
          cov_1hl321vx4v.f[8]++;
          cov_1hl321vx4v.s[74]++;

          item.imageUrl = $deltahttp.getFormularRespositoy(item.id);
          cov_1hl321vx4v.s[75]++;
          return item;
        });
        cov_1hl321vx4v.s[76]++;
        $scope.isloading = false;
        cov_1hl321vx4v.s[77]++;
        $scope.formular.cancel();
      });
    },
    add: function add() {
      cov_1hl321vx4v.s[78]++;

      this.edit({
        NAME: '',
        STRUCTURE: [],

        ITEM: 'record',
        ITEM_P: 'records',
        PRIVATE: false,
        LAST_ID: 2,
        id: 0
      });
    },
    delete: function _delete(item, notConfirm) {
      cov_1hl321vx4v.s[79]++;

      if (notConfirm) {
        cov_1hl321vx4v.b[11][0]++;
        cov_1hl321vx4v.s[80]++;

        $CRUDService.delet(PATH, { action: 'supp', id: item.id });
        cov_1hl321vx4v.s[81]++;
        return;
      } else {
        cov_1hl321vx4v.b[11][1]++;
      }
      cov_1hl321vx4v.s[82]++;
      SweetAlert.swal({
        title: $translate.instant('COMMON.CONFIRM'),

        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#c8c8c8',

        confirmButtonText: $translate.instant('COMMON.NO'),
        cancelButtonText: $translate.instant('COMMON.YES'),
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isconfirm) {
        cov_1hl321vx4v.f[9]++;
        cov_1hl321vx4v.s[83]++;

        if (isconfirm) {
          cov_1hl321vx4v.b[12][0]++;
          cov_1hl321vx4v.s[84]++;

          return;
        } else {
          cov_1hl321vx4v.b[12][1]++;
        }
        cov_1hl321vx4v.s[85]++;
        $scope.isloading = true;
        cov_1hl321vx4v.s[86]++;
        $CRUDService.delet(PATH, { action: 'supp', id: item.id }, function (data) {
          cov_1hl321vx4v.f[10]++;
          cov_1hl321vx4v.s[87]++;

          $scope.formular.cancel();
          cov_1hl321vx4v.s[88]++;
          $scope.formular.getAll();
        });
      });
    },
    cancel: function cancel() {
      cov_1hl321vx4v.s[89]++;

      $scope.formular.editItem = null;
      cov_1hl321vx4v.s[90]++;
      $scope.view = 1;
      cov_1hl321vx4v.s[91]++;
      $scope.setLoading(false);
    },
    validateItem: function validateItem() {
      var dataStruct = (cov_1hl321vx4v.s[92]++, []);
      cov_1hl321vx4v.s[93]++;
      for (var _iterator7 = $scope.formular.editItem.TAB_FORM, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
        var _ref7;

        if (_isArray7) {
          if (_i7 >= _iterator7.length) break;
          _ref7 = _iterator7[_i7++];
        } else {
          _i7 = _iterator7.next();
          if (_i7.done) break;
          _ref7 = _i7.value;
        }

        var struct = _ref7;
        cov_1hl321vx4v.s[94]++;

        dataStruct = dataStruct.concat($scope.formular.editItem.STRUCTURE[struct.id]);
      }
      cov_1hl321vx4v.s[95]++;
      $scope.formular.editItem.STRUCTURE = dataStruct;
      cov_1hl321vx4v.s[96]++;
      if ($scope.formular.editItem.STRUCTURE.length == 0) {
        cov_1hl321vx4v.b[13][0]++;
        cov_1hl321vx4v.s[97]++;

        return;
      } else {
        cov_1hl321vx4v.b[13][1]++;
      }
      cov_1hl321vx4v.s[98]++;
      for (var _iterator8 = $scope.formular.editItem.STRUCTURE, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
        var _ref8;

        if (_isArray8) {
          if (_i8 >= _iterator8.length) break;
          _ref8 = _iterator8[_i8++];
        } else {
          _i8 = _iterator8.next();
          if (_i8.done) break;
          _ref8 = _i8.value;
        }

        var el = _ref8;
        cov_1hl321vx4v.s[99]++;

        if ((cov_1hl321vx4v.b[15][0]++, el.type == 6) || (cov_1hl321vx4v.b[15][1]++, el.type == 2) && (cov_1hl321vx4v.b[15][2]++, el.type_option == 3)) {
          cov_1hl321vx4v.b[14][0]++;
          cov_1hl321vx4v.s[100]++;

          if (el.options.length == 0) {
            cov_1hl321vx4v.b[16][0]++;
            cov_1hl321vx4v.s[101]++;

            return;
          } else {
            cov_1hl321vx4v.b[16][1]++;
          }
        } else {
          cov_1hl321vx4v.b[14][1]++;
        }
      }

      var length = (cov_1hl321vx4v.s[102]++, $scope.formular.editItem.STRUCTURE.length);
      cov_1hl321vx4v.s[103]++;


      if ($scope.formular.editItem.id > 0) {
        cov_1hl321vx4v.b[17][0]++;

        var form = (cov_1hl321vx4v.s[104]++, $scope.formular.oldForm);
        cov_1hl321vx4v.s[105]++;
        if (form) {
          cov_1hl321vx4v.b[18][0]++;

          var listId = (cov_1hl321vx4v.s[106]++, this._checkValidate(form, $scope.formular.editItem));

          cov_1hl321vx4v.s[107]++;
          if (listId.length > 0) {
            cov_1hl321vx4v.b[19][0]++;
            cov_1hl321vx4v.s[108]++;

            SweetAlert.swal({
              title: $translate.instant('FORMULAR.CONFIRM_STRUCTURE'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#c8c8c8',

              confirmButtonText: $translate.instant('COMMON.NO'),
              cancelButtonText: $translate.instant('COMMON.YES'),
              closeOnConfirm: true,
              closeOnCancel: true
            }, function (isconfirm) {
              cov_1hl321vx4v.f[11]++;
              cov_1hl321vx4v.s[109]++;

              if (isconfirm) {
                cov_1hl321vx4v.b[20][0]++;
                cov_1hl321vx4v.s[110]++;

                return;
              } else {
                cov_1hl321vx4v.b[20][1]++;
              }
              cov_1hl321vx4v.s[111]++;
              $scope.formular.editItem.LAST_ID = 0;
              var saveItem = (cov_1hl321vx4v.s[112]++, angular.copy($scope.formular.editItem));
              cov_1hl321vx4v.s[113]++;
              $scope.isloading = true;
              cov_1hl321vx4v.s[114]++;
              for (var _iterator9 = listId, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
                var _ref9;

                if (_isArray9) {
                  if (_i9 >= _iterator9.length) break;
                  _ref9 = _iterator9[_i9++];
                } else {
                  _i9 = _iterator9.next();
                  if (_i9.done) break;
                  _ref9 = _i9.value;
                }

                var id__ = _ref9;
                cov_1hl321vx4v.s[115]++;

                $scope.formular.delete({ id: id__ }, true);
              }
              cov_1hl321vx4v.s[116]++;
              $CRUDService.save(PATH, { action: 'MiseAJour', valeur: saveItem }, function (data) {
                cov_1hl321vx4v.f[12]++;
                cov_1hl321vx4v.s[117]++;

                $scope.formular.cancel();
                cov_1hl321vx4v.s[118]++;
                $scope.formular.getAll();
              });
            });
            cov_1hl321vx4v.s[119]++;
            return;
          } else {
            cov_1hl321vx4v.b[19][1]++;
          }
        } else {
          cov_1hl321vx4v.b[18][1]++;
        }
      } else {
        cov_1hl321vx4v.b[17][1]++;
      }
      cov_1hl321vx4v.s[120]++;
      $scope.formular.editItem.LAST_ID = 0;
      var saveItem = (cov_1hl321vx4v.s[121]++, angular.copy($scope.formular.editItem));
      cov_1hl321vx4v.s[122]++;
      $scope.isloading = true;
      cov_1hl321vx4v.s[123]++;
      $CRUDService.save(PATH, { action: 'MiseAJour', valeur: saveItem }, function (data) {
        cov_1hl321vx4v.f[13]++;
        cov_1hl321vx4v.s[124]++;

        $scope.formular.cancel();
        cov_1hl321vx4v.s[125]++;
        $scope.formular.getAll();
      });
    },
    _checkValidate: function _checkValidate(oldForm, newForm) {
      var oldStructureList = (cov_1hl321vx4v.s[126]++, $filter('filter')(oldForm.STRUCTURE, { type: 12 }, true));
      var newStructureList = (cov_1hl321vx4v.s[127]++, $filter('filter')(newForm.STRUCTURE, { type: 12 }, true));

      cov_1hl321vx4v.s[128]++;
      if (oldStructureList.length == 0) {
        cov_1hl321vx4v.b[21][0]++;
        cov_1hl321vx4v.s[129]++;

        return [];
      } else {
        cov_1hl321vx4v.b[21][1]++;
      }

      var value = (cov_1hl321vx4v.s[130]++, []);
      cov_1hl321vx4v.s[131]++;
      for (var _iterator10 = oldStructureList, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
        var _ref10;

        if (_isArray10) {
          if (_i10 >= _iterator10.length) break;
          _ref10 = _iterator10[_i10++];
        } else {
          _i10 = _iterator10.next();
          if (_i10.done) break;
          _ref10 = _i10.value;
        }

        var _oldForm = _ref10;

        var _newForm = (cov_1hl321vx4v.s[132]++, $filter('filter')(newStructureList, { id: _oldForm.id }, true)[0]);
        cov_1hl321vx4v.s[133]++;
        if (!_newForm) {
          cov_1hl321vx4v.b[22][0]++;
          cov_1hl321vx4v.s[134]++;

          value.push(_oldForm.id);
        } else {
          cov_1hl321vx4v.b[22][1]++;
          cov_1hl321vx4v.s[135]++;

          value = value.concat(this._checkValidate(_oldForm, _newForm));
        }
      }
      cov_1hl321vx4v.s[136]++;
      return value;
    },
    openrecord: function openrecord(item, notNew) {
      cov_1hl321vx4v.s[137]++;

      if (item == null) {
        cov_1hl321vx4v.b[23][0]++;
        cov_1hl321vx4v.s[138]++;

        return;
      } else {
        cov_1hl321vx4v.b[23][1]++;
      }
      cov_1hl321vx4v.s[139]++;
      if (!notNew) {
        cov_1hl321vx4v.b[24][0]++;
        cov_1hl321vx4v.s[140]++;

        this.formTree = [];
        cov_1hl321vx4v.s[141]++;
        this.RIGHT = item.RIGHT_;
        cov_1hl321vx4v.s[142]++;
        this.OWNERUSER = item.IDUSER;
      } else {
        cov_1hl321vx4v.b[24][1]++;
        cov_1hl321vx4v.s[143]++;

        $scope.records.sort = null;
      }
      cov_1hl321vx4v.s[144]++;
      $scope.view = 3;
      cov_1hl321vx4v.s[145]++;
      if (item) {
        cov_1hl321vx4v.b[25][0]++;
        cov_1hl321vx4v.s[146]++;

        this.editItem = item;
      } else {
        cov_1hl321vx4v.b[25][1]++;
      }
      cov_1hl321vx4v.s[147]++;
      $scope.records.listDataBasePerso = {};
      cov_1hl321vx4v.s[148]++;
      $scope.records.view = 1;
      cov_1hl321vx4v.s[149]++;
      $scope.isloading = true;
      cov_1hl321vx4v.s[150]++;
      $CRUDService.getAll(PATH, { get: 'getOne', id: item.id }, function (data) {
        cov_1hl321vx4v.f[14]++;
        cov_1hl321vx4v.s[151]++;

        $scope.formular.editItem.STRUCTURE = data.STRUCTURE;
        cov_1hl321vx4v.s[152]++;
        $scope.formular.editItem.TAB_FORM = data.TAB_FORM;
        cov_1hl321vx4v.s[153]++;
        if (!notNew) {
          cov_1hl321vx4v.b[26][0]++;
          cov_1hl321vx4v.s[154]++;

          $scope.formular.oldForm = data;
        } else {
          cov_1hl321vx4v.b[26][1]++;
        }

        cov_1hl321vx4v.s[155]++;
        if ($scope.records.sort == null) {
          cov_1hl321vx4v.b[27][0]++;
          cov_1hl321vx4v.s[156]++;

          $scope.records.sort = [{ id: data.MAIN, type: 1 }];
        } else {
          cov_1hl321vx4v.b[27][1]++;
        }

        var listData = (cov_1hl321vx4v.s[157]++, $filter('filter')(data.STRUCTURE, { type: 2, type_option: '2' }, true));
        cov_1hl321vx4v.s[158]++;

        var _loop = function _loop() {
          if (_isArray11) {
            if (_i11 >= _iterator11.length) return 'break';
            _ref11 = _iterator11[_i11++];
          } else {
            _i11 = _iterator11.next();
            if (_i11.done) return 'break';
            _ref11 = _i11.value;
          }

          var el = _ref11;

          var id = (cov_1hl321vx4v.s[159]++, el.optionp);
          cov_1hl321vx4v.s[160]++;
          if (angular.isDefined($scope.records.listDataBasePerso[id])) {
            cov_1hl321vx4v.b[28][0]++;
            cov_1hl321vx4v.s[161]++;

            return 'continue';
          } else {
            cov_1hl321vx4v.b[28][1]++;
          }
          cov_1hl321vx4v.s[162]++;
          $scope.records.listDataBasePerso[id] = { struct: {}, data: [] };

          cov_1hl321vx4v.s[163]++;
          $CRUDService.getAll(PATH, { get: 'all_r', id: id }, function (data) {
            cov_1hl321vx4v.f[15]++;
            cov_1hl321vx4v.s[164]++;

            $scope.records.listDataBasePerso[id].data = data;
          });

          cov_1hl321vx4v.s[165]++;
          $CRUDService.getAll(PATH, { get: 'getOne', id: id }, function (data) {
            cov_1hl321vx4v.f[16]++;
            cov_1hl321vx4v.s[166]++;

            $scope.records.listDataBasePerso[id].struct = data;
          });
        };

        _loop2: for (var _iterator11 = listData, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
          var _ref11;

          var _ret = _loop();

          switch (_ret) {
            case 'break':
              break _loop2;

            case 'continue':
              continue;}
        }

        cov_1hl321vx4v.s[167]++;

        $scope.request.getAll();
      });
    },
    edit: function edit(item) {
      var item_ = (cov_1hl321vx4v.s[168]++, angular.copy(item));
      cov_1hl321vx4v.s[169]++;
      if (item.id > 0) {
        cov_1hl321vx4v.b[29][0]++;
        cov_1hl321vx4v.s[170]++;

        $scope.isloading = true;
        cov_1hl321vx4v.s[171]++;
        $CRUDService.getAll(PATH, { get: 'getOne', id: item.id }, function (data) {
          cov_1hl321vx4v.f[17]++;
          cov_1hl321vx4v.s[172]++;

          $scope.isloading = false;
          cov_1hl321vx4v.s[173]++;
          item_ = angular.copy(data);
          cov_1hl321vx4v.s[174]++;
          item_.STRUCTURE = {};
          cov_1hl321vx4v.s[175]++;
          if (!data.TAB_FORM) {
            cov_1hl321vx4v.b[30][0]++;
            cov_1hl321vx4v.s[176]++;

            item_.TAB_FORM = [{ id: getLastId(), l: '1' }];
          } else {
            cov_1hl321vx4v.b[30][1]++;
          }

          cov_1hl321vx4v.s[177]++;
          for (var _iterator12 = data.TAB_FORM, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
            var _ref12;

            if (_isArray12) {
              if (_i12 >= _iterator12.length) break;
              _ref12 = _iterator12[_i12++];
            } else {
              _i12 = _iterator12.next();
              if (_i12.done) break;
              _ref12 = _i12.value;
            }

            var tab = _ref12;
            cov_1hl321vx4v.s[178]++;

            item_.STRUCTURE[tab.id] = [];
          }

          cov_1hl321vx4v.s[179]++;
          for (var _iterator13 = data.STRUCTURE, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
            var _ref13;

            if (_isArray13) {
              if (_i13 >= _iterator13.length) break;
              _ref13 = _iterator13[_i13++];
            } else {
              _i13 = _iterator13.next();
              if (_i13.done) break;
              _ref13 = _i13.value;
            }

            var item_str = _ref13;
            cov_1hl321vx4v.s[180]++;

            if (!item_.STRUCTURE[item_str.o]) {
              cov_1hl321vx4v.b[31][0]++;
              cov_1hl321vx4v.s[181]++;

              item_.STRUCTURE[item_str.o] = [];
            } else {
              cov_1hl321vx4v.b[31][1]++;
            }
            cov_1hl321vx4v.s[182]++;
            item_.STRUCTURE[item_str.o].push(item_str);
          }
          cov_1hl321vx4v.s[183]++;
          $scope.formular.indexEdit = data.TAB_FORM[0].id;
          cov_1hl321vx4v.s[184]++;
          $scope.formular.changeOnglet();
          cov_1hl321vx4v.s[185]++;
          openeditfomulaire(item_);
        });
        cov_1hl321vx4v.s[186]++;
        return;
      } else {
        cov_1hl321vx4v.b[29][1]++;
      }
      cov_1hl321vx4v.s[187]++;
      item_.STRUCTURE = {};
      cov_1hl321vx4v.s[188]++;
      if (!item_.TAB_FORM) {
        cov_1hl321vx4v.b[32][0]++;
        cov_1hl321vx4v.s[189]++;

        item_.TAB_FORM = [{ id: getLastId(), l: '1' }];
      } else {
        cov_1hl321vx4v.b[32][1]++;
      }
      cov_1hl321vx4v.s[190]++;
      for (var _iterator14 = item_.TAB_FORM, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
        var _ref14;

        if (_isArray14) {
          if (_i14 >= _iterator14.length) break;
          _ref14 = _iterator14[_i14++];
        } else {
          _i14 = _iterator14.next();
          if (_i14.done) break;
          _ref14 = _i14.value;
        }

        var tab = _ref14;
        cov_1hl321vx4v.s[191]++;

        item_.STRUCTURE[tab.id] = [];
      }
      cov_1hl321vx4v.s[192]++;

      $scope.formular.indexEdit = item_.TAB_FORM[0].id;
      cov_1hl321vx4v.s[193]++;
      $scope.formular.changeOnglet();
      cov_1hl321vx4v.s[194]++;
      openeditfomulaire(item_);
    },
    editField: function editField() {
      cov_1hl321vx4v.s[195]++;

      $scope.field.formTree = [];
      cov_1hl321vx4v.s[196]++;
      $scope.view = 2;
    },
    addOnglet: function addOnglet() {
      var id = (cov_1hl321vx4v.s[197]++, getLastId());
      cov_1hl321vx4v.s[198]++;
      $scope.formular.editItem.TAB_FORM.push({ l: '', id: id });
      var tab = (cov_1hl321vx4v.s[199]++, $scope.formular.editItem.TAB_FORM[$scope.formular.editItem.TAB_FORM.length - 1]);
      cov_1hl321vx4v.s[200]++;
      $scope.formular.editItem.STRUCTURE[tab.id] = [];
      cov_1hl321vx4v.s[201]++;
      this.editOnglet(tab);
    },
    editOnglet: function editOnglet(item) {
      cov_1hl321vx4v.s[202]++;

      this.isOngletEdit = item.id;
      cov_1hl321vx4v.s[203]++;
      this.labelTampon = item.l;
    },
    validateOnglet: function validateOnglet() {
      cov_1hl321vx4v.s[204]++;

      if (this.labelTampon == '') {
        cov_1hl321vx4v.b[33][0]++;
        cov_1hl321vx4v.s[205]++;

        return;
      } else {
        cov_1hl321vx4v.b[33][1]++;
      }
      cov_1hl321vx4v.s[206]++;
      for (var _iterator15 = $scope.formular.editItem.TAB_FORM, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;) {
        var _ref15;

        if (_isArray15) {
          if (_i15 >= _iterator15.length) break;
          _ref15 = _iterator15[_i15++];
        } else {
          _i15 = _iterator15.next();
          if (_i15.done) break;
          _ref15 = _i15.value;
        }

        var el = _ref15;
        cov_1hl321vx4v.s[207]++;

        if (this.isOngletEdit == el.id) {
          cov_1hl321vx4v.b[34][0]++;
          cov_1hl321vx4v.s[208]++;

          el.l = this.labelTampon;
          cov_1hl321vx4v.s[209]++;
          this.indexEdit = el.id;
          cov_1hl321vx4v.s[210]++;
          this.changeOnglet();
          cov_1hl321vx4v.s[211]++;
          break;
        } else {
          cov_1hl321vx4v.b[34][1]++;
        }
      }
      cov_1hl321vx4v.s[212]++;
      this.isOngletEdit = 0;
    },
    cancelOnglet: function cancelOnglet() {
      var length = (cov_1hl321vx4v.s[213]++, $scope.formular.editItem.TAB_FORM.length);
      cov_1hl321vx4v.s[214]++;
      if (this.isOngletEdit == $scope.formular.editItem.TAB_FORM[length - 1].id) {
        cov_1hl321vx4v.b[35][0]++;
        cov_1hl321vx4v.s[215]++;

        if ($scope.formular.editItem.TAB_FORM[length - 1].l == '') {
          cov_1hl321vx4v.b[36][0]++;
          cov_1hl321vx4v.s[216]++;

          $scope.formular.editItem.TAB_FORM.pop();
        } else {
          cov_1hl321vx4v.b[36][1]++;
        }
      } else {
        cov_1hl321vx4v.b[35][1]++;
      }
      cov_1hl321vx4v.s[217]++;
      this.isOngletEdit = 0;
    },
    changeOnglet: function changeOnglet() {
      cov_1hl321vx4v.s[218]++;

      for (var _iterator16 = this.listItem, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : _iterator16[Symbol.iterator]();;) {
        var _ref16;

        if (_isArray16) {
          if (_i16 >= _iterator16.length) break;
          _ref16 = _iterator16[_i16++];
        } else {
          _i16 = _iterator16.next();
          if (_i16.done) break;
          _ref16 = _i16.value;
        }

        var el = _ref16;
        cov_1hl321vx4v.s[219]++;

        el.id = getLastId();cov_1hl321vx4v.s[220]++;

        el.o = this.indexEdit;
      }
    },
    deleteOnglet: function deleteOnglet(index) {
      var indexSelected = (cov_1hl321vx4v.s[221]++, 0);
      cov_1hl321vx4v.s[222]++;
      for (var i = $scope.formular.editItem.TAB_FORM.length - 1; i >= 0; i--) {
        cov_1hl321vx4v.s[223]++;

        if ($scope.formular.editItem.TAB_FORM[i].id == this.indexEdit) {
          cov_1hl321vx4v.b[37][0]++;
          cov_1hl321vx4v.s[224]++;

          indexSelected = i;
        } else {
          cov_1hl321vx4v.b[37][1]++;
        }
      }
      cov_1hl321vx4v.s[225]++;
      if ($scope.formular.editItem.TAB_FORM.length <= 1) {
        cov_1hl321vx4v.b[38][0]++;
        cov_1hl321vx4v.s[226]++;

        return;
      } else {
        cov_1hl321vx4v.b[38][1]++;
      }
      cov_1hl321vx4v.s[227]++;
      $scope.formular.editItem.STRUCTURE[$scope.formular.editItem.TAB_FORM[index].id] = undefined;
      cov_1hl321vx4v.s[228]++;
      $scope.formular.editItem.TAB_FORM.splice(index, 1);
      cov_1hl321vx4v.s[229]++;
      if (indexSelected >= index) {
        cov_1hl321vx4v.b[39][0]++;
        cov_1hl321vx4v.s[230]++;

        indexSelected--;
        cov_1hl321vx4v.s[231]++;
        if (indexSelected < 0) {
          cov_1hl321vx4v.b[40][0]++;
          cov_1hl321vx4v.s[232]++;

          indexSelected = 0;
        } else {
          cov_1hl321vx4v.b[40][1]++;
        }
      } else {
        cov_1hl321vx4v.b[39][1]++;
      }
      cov_1hl321vx4v.s[233]++;
      this.indexEdit = ((cov_1hl321vx4v.b[41][0]++, $scope.formular.editItem.TAB_FORM[indexSelected]) || (cov_1hl321vx4v.b[41][1]++, { id: 0 })).id;
      cov_1hl321vx4v.s[234]++;
      this.changeOnglet();
    },
    canDeleteOnglet: function canDeleteOnglet(index) {
      cov_1hl321vx4v.s[235]++;

      return $scope.formular.editItem.STRUCTURE[index][0];
    },
    canDrag: function canDrag() {
      cov_1hl321vx4v.s[236]++;

      return $scope.formular.editItem.STRUCTURE[this.indexEdit].length < 10;
    }
  };
  cov_1hl321vx4v.s[237]++;
  $scope.field = {
    formTree: [],
    editSubForm: function editSubForm(item) {
      cov_1hl321vx4v.s[238]++;

      this.formTree.push(angular.copy($scope.formular.editItem));
      cov_1hl321vx4v.s[239]++;
      if (item.STRUCTURE == null) {
        cov_1hl321vx4v.b[42][0]++;
        cov_1hl321vx4v.s[240]++;

        item.STRUCTURE = {};
        cov_1hl321vx4v.s[241]++;
        item.STRUCTURE[item.TAB_FORM[0].id] = [];
      } else {
        cov_1hl321vx4v.b[42][1]++;
      }
      cov_1hl321vx4v.s[242]++;
      $scope.formular.editItem = item;
      cov_1hl321vx4v.s[243]++;
      $scope.formular.indexEdit = $scope.formular.editItem.TAB_FORM[0].id;
      cov_1hl321vx4v.s[244]++;
      $scope.formular.changeOnglet();
    },
    cancelSubForm: function cancelSubForm() {
      cov_1hl321vx4v.s[245]++;

      $scope.formular.editItem = this.formTree.pop();
      cov_1hl321vx4v.s[246]++;
      $scope.formular.indexEdit = $scope.formular.editItem.TAB_FORM[0].id;
      cov_1hl321vx4v.s[247]++;
      $scope.formular.changeOnglet();
    },
    validateSubForm: function validateSubForm() {
      var item = (cov_1hl321vx4v.s[248]++, angular.copy($scope.formular.editItem));
      cov_1hl321vx4v.s[249]++;
      $scope.formular.editItem = this.formTree.pop();

      cov_1hl321vx4v.s[250]++;
      for (var _iterator17 = $scope.formular.editItem.TAB_FORM, _isArray17 = Array.isArray(_iterator17), _i17 = 0, _iterator17 = _isArray17 ? _iterator17 : _iterator17[Symbol.iterator]();;) {
        var _ref17;

        if (_isArray17) {
          if (_i17 >= _iterator17.length) break;
          _ref17 = _iterator17[_i17++];
        } else {
          _i17 = _iterator17.next();
          if (_i17.done) break;
          _ref17 = _i17.value;
        }

        var tab = _ref17;
        cov_1hl321vx4v.s[251]++;

        if (tab.id != item.o) {
          cov_1hl321vx4v.b[43][0]++;
          cov_1hl321vx4v.s[252]++;

          continue;
        } else {
          cov_1hl321vx4v.b[43][1]++;
        }
        cov_1hl321vx4v.s[253]++;
        for (var index = $scope.formular.editItem.STRUCTURE[tab.id].length - 1; index >= 0; index--) {
          cov_1hl321vx4v.s[254]++;

          if ($scope.formular.editItem.STRUCTURE[tab.id][index].id == item.id) {
            cov_1hl321vx4v.b[44][0]++;
            cov_1hl321vx4v.s[255]++;

            $scope.formular.editItem.STRUCTURE[tab.id][index] = item;
            cov_1hl321vx4v.s[256]++;
            break;
          } else {
            cov_1hl321vx4v.b[44][1]++;
          }
        }
        cov_1hl321vx4v.s[257]++;
        break;
      }
      cov_1hl321vx4v.s[258]++;
      $scope.formular.indexEdit = $scope.formular.editItem.TAB_FORM[0].id;
      cov_1hl321vx4v.s[259]++;
      $scope.formular.changeOnglet();
    },
    edit: function edit(item) {
      var template = (cov_1hl321vx4v.s[260]++, 'app/views/formular/fieldoption/');
      cov_1hl321vx4v.s[261]++;
      switch (item.type) {
        case 1:
          cov_1hl321vx4v.b[45][0]++;
        case 3:
          cov_1hl321vx4v.b[45][1]++;
        case 4:
          cov_1hl321vx4v.b[45][2]++;
          cov_1hl321vx4v.s[262]++;

          template += 'textfield';
          cov_1hl321vx4v.s[263]++;
          break;
        case 6:
          cov_1hl321vx4v.b[45][3]++;
          cov_1hl321vx4v.s[264]++;

          template += 'optionfield';
          cov_1hl321vx4v.s[265]++;
          break;
        case 2:
          cov_1hl321vx4v.b[45][4]++;
          cov_1hl321vx4v.s[266]++;

          template += 'listfield';
          cov_1hl321vx4v.s[267]++;
          break;
        case 12:
          cov_1hl321vx4v.b[45][5]++;
          cov_1hl321vx4v.s[268]++;

          template += 'subform';
          cov_1hl321vx4v.s[269]++;
          break;
        default:
          cov_1hl321vx4v.b[45][6]++;

      }
      cov_1hl321vx4v.s[270]++;
      $scope.field.originalItem = item;
      cov_1hl321vx4v.s[271]++;
      this.editItem = angular.copy(item);

      cov_1hl321vx4v.s[272]++;
      if (this.editItem.cat) {
        cov_1hl321vx4v.b[46][0]++;
        cov_1hl321vx4v.s[273]++;

        this.editItem.cat = $filter('filter')($scope.listCategories, { id: this.editItem.cat }, true)[0];
      } else {
        cov_1hl321vx4v.b[46][1]++;
      }

      cov_1hl321vx4v.s[274]++;
      template += '.html';
      cov_1hl321vx4v.s[275]++;
      $uibModal.open({
        templateUrl: template,
        controller: FormulaireCtrl_editField,
        scope: $scope,
        size: 'sm_',
        backdrop: 'static',
        windowClass: 'animated fadeInRight left-modal'
      });
    },
    delete: function _delete(item) {
      var index = (cov_1hl321vx4v.s[276]++, $scope.formular.editItem.STRUCTURE[$scope.formular.indexEdit].indexOf(item));
      cov_1hl321vx4v.s[277]++;
      if (index >= 0) {
        cov_1hl321vx4v.b[47][0]++;
        cov_1hl321vx4v.s[278]++;

        $scope.formular.editItem.STRUCTURE[$scope.formular.indexEdit].splice(index, 1);
      } else {
        cov_1hl321vx4v.b[47][1]++;
      }
    },
    validateEdit: function validateEdit() {
      cov_1hl321vx4v.s[279]++;

      if ((cov_1hl321vx4v.b[49][0]++, this.editItem.cat) && (cov_1hl321vx4v.b[49][1]++, this.editItem.optionp == 'aggregate') && (cov_1hl321vx4v.b[49][2]++, this.editItem.type_option == 1)) {
        cov_1hl321vx4v.b[48][0]++;
        cov_1hl321vx4v.s[280]++;

        this.editItem.cat = this.editItem.cat.id;
      } else {
        cov_1hl321vx4v.b[48][1]++;
        cov_1hl321vx4v.s[281]++;

        this.editItem.cat = undefined;
      }
      var index = (cov_1hl321vx4v.s[282]++, $scope.formular.editItem.STRUCTURE[$scope.formular.indexEdit].indexOf($scope.field.originalItem));
      cov_1hl321vx4v.s[283]++;
      if (index >= 0) {
        cov_1hl321vx4v.b[50][0]++;
        cov_1hl321vx4v.s[284]++;

        $scope.formular.editItem.STRUCTURE[$scope.formular.indexEdit][index] = this.editItem;
      } else {
        cov_1hl321vx4v.b[50][1]++;
      }
    },
    addchoiseoption: function addchoiseoption(item) {
      cov_1hl321vx4v.s[285]++;

      if (!this.option_new) {
        cov_1hl321vx4v.b[51][0]++;
        cov_1hl321vx4v.s[286]++;

        return;
      } else {
        cov_1hl321vx4v.b[51][1]++;
      }
      cov_1hl321vx4v.s[287]++;
      if (this.option_new == '') {
        cov_1hl321vx4v.b[52][0]++;
        cov_1hl321vx4v.s[288]++;

        return;
      } else {
        cov_1hl321vx4v.b[52][1]++;
      }
      var opt = (cov_1hl321vx4v.s[289]++, angular.copy(this.option_new).trim());
      var index = (cov_1hl321vx4v.s[290]++, item.options.indexOf(opt));
      cov_1hl321vx4v.s[291]++;
      if (index >= 0) {
        cov_1hl321vx4v.b[53][0]++;
        cov_1hl321vx4v.s[292]++;

        return;
      } else {
        cov_1hl321vx4v.b[53][1]++;
      }
      cov_1hl321vx4v.s[293]++;
      item.options.push(opt);
      cov_1hl321vx4v.s[294]++;
      this.option_new = '';
    },
    deletechoiseoption: function deletechoiseoption(item) {
      var index = (cov_1hl321vx4v.s[295]++, $scope.field.editItem.options.indexOf(item));
      cov_1hl321vx4v.s[296]++;
      if (index >= 0) {
        cov_1hl321vx4v.b[54][0]++;
        cov_1hl321vx4v.s[297]++;

        $scope.field.editItem.options.splice(index, 1);
      } else {
        cov_1hl321vx4v.b[54][1]++;
      }
    }
  };

  cov_1hl321vx4v.s[298]++;

  $CRUDService.getAll('User', { get: 'NonAdmin' }, function (data) {
    cov_1hl321vx4v.f[18]++;
    cov_1hl321vx4v.s[299]++;

    $scope.dataUser = data;
    cov_1hl321vx4v.s[300]++;
    $scope.formular.getAll();
  });

  var uploader = (cov_1hl321vx4v.s[301]++, $scope.uploader = new FileUploader({
    url: $CRUDService.getServerAdress() + 'web_server.php?action=loadimg&method=1&' + $CRUDService.getComplement() + '&li_bksb=' + PATH,
    headers: $CRUDService.getHeader(),
    alias: 'img',
    removeAfterUpload: true
  }));
  cov_1hl321vx4v.s[302]++;
  uploader.onAfterAddingFile = function (fileItem, a, b, c, d, e) {
    cov_1hl321vx4v.f[19]++;
    cov_1hl321vx4v.s[303]++;

    fileItem.formular.showprogress = true;
    cov_1hl321vx4v.s[304]++;
    fileItem.url = uploader.url + '&formular=' + fileItem.formular.id;
    cov_1hl321vx4v.s[305]++;
    for (var i = 0; i <= $scope.listFormular.length; i++) {
      cov_1hl321vx4v.s[306]++;

      if ($scope.listFormular[i].id == fileItem.formular.id) {
        cov_1hl321vx4v.b[55][0]++;
        cov_1hl321vx4v.s[307]++;

        $scope.listFormular[i].loading = true;
        cov_1hl321vx4v.s[308]++;
        break;
      } else {
        cov_1hl321vx4v.b[55][1]++;
      }
    }

    cov_1hl321vx4v.s[309]++;
    fileItem.upload();
  };
  cov_1hl321vx4v.s[310]++;
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    cov_1hl321vx4v.f[20]++;
    cov_1hl321vx4v.s[311]++;

    for (var i = 0; i <= $scope.listFormular.length; i++) {
      cov_1hl321vx4v.s[312]++;

      if ($scope.listFormular[i].id == fileItem.formular.id) {
        cov_1hl321vx4v.b[56][0]++;
        cov_1hl321vx4v.s[313]++;

        $scope.listFormular[i].ICON = Date.newDate();
        cov_1hl321vx4v.s[314]++;
        $scope.listFormular[i].loading = undefined;
        cov_1hl321vx4v.s[315]++;
        break;
      } else {
        cov_1hl321vx4v.b[56][1]++;
      }
    }
  };
  cov_1hl321vx4v.s[316]++;
  uploader.onErrorItem = function (fileItem, response, status, headers) {
    cov_1hl321vx4v.f[21]++;
    cov_1hl321vx4v.s[317]++;

    fileItem.formular.showprogress = false;
  };
});

function customDatabaseDesign_edit($scope, $uibModalInstance, $filter, $CRUDService) {
  cov_1hl321vx4v.f[22]++;
  cov_1hl321vx4v.s[318]++;

  $scope.setValidData = function () {
    cov_1hl321vx4v.f[23]++;

    var validateItem = (cov_1hl321vx4v.s[319]++, $scope.formular.editItem);
    var item = (cov_1hl321vx4v.s[320]++, $filter('filter')($scope.listFormular, { NAME: validateItem.NAME }, true)[0]);
    cov_1hl321vx4v.s[321]++;
    if ((cov_1hl321vx4v.b[58][0]++, item) && (cov_1hl321vx4v.b[58][1]++, item.id != validateItem.id)) {
      cov_1hl321vx4v.b[57][0]++;
      cov_1hl321vx4v.s[322]++;

      error = 1;
      cov_1hl321vx4v.s[323]++;
      $scope.error_code = true;
      cov_1hl321vx4v.s[324]++;
      return;
    } else {
      cov_1hl321vx4v.b[57][1]++;
    }
    cov_1hl321vx4v.s[325]++;
    $scope.formular.editField();
    cov_1hl321vx4v.s[326]++;
    $uibModalInstance.dismiss('cancel');
  };
  cov_1hl321vx4v.s[327]++;
  $scope.closeModal = function () {
    cov_1hl321vx4v.f[24]++;
    cov_1hl321vx4v.s[328]++;

    $uibModalInstance.dismiss('cancel');
  };
}
function customDatabaseDesign_subform($scope, $uibModalInstance, $filter, $CRUDService) {
  cov_1hl321vx4v.f[25]++;
  cov_1hl321vx4v.s[329]++;

  $scope.setValidData = function () {
    cov_1hl321vx4v.f[26]++;

    var validateItem = (cov_1hl321vx4v.s[330]++, $scope.formular.editItem);
    var item = (cov_1hl321vx4v.s[331]++, $filter('filter')($scope.listFormular, { NAME: validateItem.NAME }, true)[0]);
    cov_1hl321vx4v.s[332]++;
    if ((cov_1hl321vx4v.b[60][0]++, item) && (cov_1hl321vx4v.b[60][1]++, item.id != validateItem.id)) {
      cov_1hl321vx4v.b[59][0]++;
      cov_1hl321vx4v.s[333]++;

      error = 1;
      cov_1hl321vx4v.s[334]++;
      $scope.error_code = true;
      cov_1hl321vx4v.s[335]++;
      return;
    } else {
      cov_1hl321vx4v.b[59][1]++;
    }
    cov_1hl321vx4v.s[336]++;
    $scope.formular.editField();
    cov_1hl321vx4v.s[337]++;
    $uibModalInstance.dismiss('cancel');
  };
  cov_1hl321vx4v.s[338]++;
  $scope.closeModal = function () {
    cov_1hl321vx4v.f[27]++;
    cov_1hl321vx4v.s[339]++;

    $uibModalInstance.dismiss('cancel');
  };
}

function customDatabaseDesign_editField($scope, $uibModalInstance, $filter, $CRUDService) {
  cov_1hl321vx4v.f[28]++;
  cov_1hl321vx4v.s[340]++;

  $scope.validateEditField = function () {
    cov_1hl321vx4v.f[29]++;
    cov_1hl321vx4v.s[341]++;

    $scope.field.validateEdit();
    cov_1hl321vx4v.s[342]++;
    $uibModalInstance.dismiss('cancel');
  };
  cov_1hl321vx4v.s[343]++;
  $scope.closeModal = function () {
    cov_1hl321vx4v.f[30]++;
    cov_1hl321vx4v.s[344]++;

    $uibModalInstance.dismiss('cancel');
  };
}